/*jshint -W087 */
/*jshint sub:true*/
/*jshint esnext: true */
/*jshint loopfunc:true */

// CustomEvent polyfill
(function() {
  if (typeof window.CustomEvent === "function") return false; //If not IE

  function CustomEvent(event, params) {
	params = params || { bubbles: false, cancelable: false, detail: undefined };
	var evt = document.createEvent("CustomEvent");
	evt.initCustomEvent(
	  event,
	  params.bubbles,
	  params.cancelable,
	  params.detail
	);
	return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

if (typeof theme === "undefined") {
  theme = {};
}
var html = $("html");
var body = $("body");
var winWidth = $(window).width();
var winHeight = $(window).height();
theme.mobileBrkp = 768;
theme.tabletBrkp = 981;

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopify: {
      tagId: 'plyr-shopify',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr-legacy.en.js',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    shopifyXr: {
      tagId: 'shopify-model-viewer-xr',
      src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
      type: types.script
    },
    modelViewerUi: {
      tagId: 'shopify-model-viewer-ui',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
      type: types.script
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();

theme.homeMaps = function() {
  mapInit = function(mapId, mapSection, mapAddress, mapStyle, mapPin) {
	var geocoder;
	var map;

	geocoder = new google.maps.Geocoder();
	var latlng = new google.maps.LatLng(1, 1);
	var myOptions = {
	  zoom: 14,
	  center: latlng,
	  disableDefaultUI: true,
	  scrollwheel: false,
	  keyboardShortcuts: false,
	  styles: mapStyles[mapStyle]
	};
	map = new google.maps.Map(document.getElementById(mapId), myOptions);

	if (geocoder) {
	  geocoder.geocode({ address: mapAddress }, function(results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
		  if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
			map.setCenter(results[0].geometry.location);

			var marker = new google.maps.Marker({
			  position: results[0].geometry.location,
			  map: map,
			  icon: window[mapPin]
			});
		  }
		}
	  });
	}
  };

  theme.runMap = function(map) {
	var thisMap = $("#" + map);

	var mapId = thisMap.data("map-id");
	var mapSection = thisMap.data("map-section");
	var mapAddress = thisMap.data("map-address");
	var mapStyle = thisMap.data("map-style");
	var mapPin = thisMap.data("map-pin");

	mapInit(mapId, mapSection, mapAddress, mapStyle, mapPin);
  };

  function eachMapInit() {
	$(".js-map-ids").each(function() {
	  var thisMapId = $(this).data("map-id");
	  theme.runMap(thisMapId);
	});
  }

  //home map accordion
  function mapTrigger() {
	var item = $(".js-map-info");
	var trigger = $(".js-map-trigger");
	var items = item.hide(); //hide all items
	var activeClass = "js-active";

	//show and acivate first item in each map
	$(".js-map").each(function(i) {
	  $(this)
		.find(item)
		.first()
		.addClass(activeClass)
		.show();
	  $(this)
		.find(trigger)
		.first()
		.addClass(activeClass);
	});

	trigger.click(function() {
	  var thisItem = $(this).attr("href");
	  var theseItems = $(thisItem)
		.parents(".js-map")
		.find(".js-map-info");

	  //check if info is not active
	  if (!$(thisItem).hasClass(activeClass)) {
		theseItems.removeClass(activeClass).slideUp();
		$(thisItem)
		  .addClass(activeClass)
		  .slideDown();
	  }

	  //map canvas functions
	  $(this)
		.parents(".js-map")
		.find(".js-map-media")
		.removeClass(activeClass); //hide all within section
	  $('.js-map-media[data-map-id="' + thisItem + '"]').addClass(activeClass); //show active

	  //run current map function if it's hidden within tab
	  if ($(thisItem).find(".home-map__media-canvas").length) {
		var thisMapId = $(thisItem)
		  .find(".home-map__media-canvas")
		  .attr("id");

		if (typeof thisMapId != "undefined") {
		  theme.runMap(thisMapId);
		}
	  }

	  //check if info is not active
	  if (!$(this).hasClass(activeClass)) {
		trigger.removeClass(activeClass);
		$(this).addClass(activeClass);
	  }

	  return false;
	});
  }
  mapTrigger();

  //lazily initiate google maps
  var lazyMap = new LazyLoad({
	elements_selector: ".js-lazy-map",
	callback_set: function(el) {
	  if ($(".js-map-ids").length > 0) {
		if (typeof window.google === "undefined") {
		  //get google key or set empty var
		  var google_key;
		  if (typeof theme.map.key !== "undefined") {
			google_key = theme.map.key;
		  } else {
			google_key = "";
		  }

		  $.getScript(
			"https://maps.googleapis.com/maps/api/js?key=" + google_key
		  ).then(function() {
			//set SVG map pins
			mapPinDark = {
			  path:
				"M50,9.799c-15.188,0-27.499,12.312-27.499,27.499S50,90.201,50,90.201s27.499-37.715,27.499-52.902S65.188,9.799,50,9.799z   M50,44.813c-4.15,0-7.515-3.365-7.515-7.515S45.85,29.784,50,29.784s7.514,3.365,7.514,7.515S54.15,44.813,50,44.813z",
			  fillColor: "#000000",
			  anchor: new google.maps.Point(55, 85),
			  fillOpacity: 1,
			  scale: 0.6,
			  strokeWeight: 0
			};
			mapPinLight = {
			  path:
				"M50,9.799c-15.188,0-27.499,12.312-27.499,27.499S50,90.201,50,90.201s27.499-37.715,27.499-52.902S65.188,9.799,50,9.799z   M50,44.813c-4.15,0-7.515-3.365-7.515-7.515S45.85,29.784,50,29.784s7.514,3.365,7.514,7.515S54.15,44.813,50,44.813z",
			  fillColor: "#ffffff",
			  anchor: new google.maps.Point(55, 85),
			  fillOpacity: 1,
			  scale: 0.6,
			  strokeWeight: 0
			};
			mapStyles = {
			  light: [
				{
				  featureType: "water",
				  elementType: "geometry",
				  stylers: [{ color: "#e9e9e9" }, { lightness: 17 }]
				},
				{
				  featureType: "landscape",
				  elementType: "geometry",
				  stylers: [{ color: "#f0f0f0" }, { lightness: 20 }]
				},
				{
				  featureType: "road.highway",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#ffffff" }, { lightness: 17 }]
				},
				{
				  featureType: "road.highway",
				  elementType: "geometry.stroke",
				  stylers: [
					{ color: "#ffffff" },
					{ lightness: 29 },
					{ weight: 0.2 }
				  ]
				},
				{
				  featureType: "road.arterial",
				  elementType: "geometry",
				  stylers: [{ color: "#ffffff" }, { lightness: 18 }]
				},
				{
				  featureType: "road.local",
				  elementType: "geometry",
				  stylers: [{ color: "#ffffff" }, { lightness: 16 }]
				},
				{
				  featureType: "poi",
				  elementType: "geometry",
				  stylers: [{ color: "#f0f0f0" }, { lightness: 21 }]
				},
				{
				  featureType: "poi.park",
				  elementType: "geometry",
				  stylers: [{ color: "#dedede" }, { lightness: 21 }]
				},
				{
				  elementType: "labels.text.stroke",
				  stylers: [
					{ visibility: "on" },
					{ color: "#ffffff" },
					{ lightness: 16 }
				  ]
				},
				{
				  elementType: "labels.text.fill",
				  stylers: [
					{ saturation: 36 },
					{ color: "#333333" },
					{ lightness: 40 }
				  ]
				},
				{
				  elementType: "labels.icon",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "transit",
				  elementType: "geometry",
				  stylers: [{ color: "#f2f2f2" }, { lightness: 19 }]
				},
				{
				  featureType: "administrative",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#fefefe" }, { lightness: 20 }]
				},
				{
				  featureType: "administrative",
				  elementType: "geometry.stroke",
				  stylers: [
					{ color: "#fefefe" },
					{ lightness: 17 },
					{ weight: 1.2 }
				  ]
				}
			  ],
			  dark: [
				{
				  featureType: "all",
				  elementType: "labels.text.fill",
				  stylers: [
					{ saturation: 36 },
					{ color: "#000000" },
					{ lightness: 40 }
				  ]
				},
				{
				  featureType: "all",
				  elementType: "labels.text.stroke",
				  stylers: [
					{ visibility: "on" },
					{ color: "#000000" },
					{ lightness: 16 }
				  ]
				},
				{
				  featureType: "all",
				  elementType: "labels.icon",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "administrative",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#000000" }, { lightness: 20 }]
				},
				{
				  featureType: "administrative",
				  elementType: "geometry.stroke",
				  stylers: [
					{ color: "#000000" },
					{ lightness: 17 },
					{ weight: 1.2 }
				  ]
				},
				{
				  featureType: "administrative",
				  elementType: "labels",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "administrative.country",
				  elementType: "all",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "administrative.country",
				  elementType: "geometry",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "administrative.country",
				  elementType: "labels.text",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "administrative.province",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "administrative.locality",
				  elementType: "all",
				  stylers: [
					{ visibility: "simplified" },
					{ saturation: "-100" },
					{ lightness: "30" }
				  ]
				},
				{
				  featureType: "administrative.neighborhood",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "administrative.land_parcel",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "landscape",
				  elementType: "all",
				  stylers: [
					{ visibility: "simplified" },
					{ gamma: "0.00" },
					{ lightness: "74" }
				  ]
				},
				{
				  featureType: "landscape",
				  elementType: "geometry",
				  stylers: [{ color: "#000000" }, { lightness: 20 }]
				},
				{
				  featureType: "landscape.man_made",
				  elementType: "all",
				  stylers: [{ lightness: "3" }]
				},
				{
				  featureType: "poi",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "poi",
				  elementType: "geometry",
				  stylers: [{ color: "#000000" }, { lightness: 21 }]
				},
				{
				  featureType: "road",
				  elementType: "geometry",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "road.highway",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#000000" }, { lightness: 17 }]
				},
				{
				  featureType: "road.highway",
				  elementType: "geometry.stroke",
				  stylers: [
					{ color: "#000000" },
					{ lightness: 29 },
					{ weight: 0.2 }
				  ]
				},
				{
				  featureType: "road.arterial",
				  elementType: "geometry",
				  stylers: [{ color: "#000000" }, { lightness: 18 }]
				},
				{
				  featureType: "road.local",
				  elementType: "geometry",
				  stylers: [{ color: "#000000" }, { lightness: 16 }]
				},
				{
				  featureType: "transit",
				  elementType: "geometry",
				  stylers: [{ color: "#000000" }, { lightness: 19 }]
				},
				{
				  featureType: "water",
				  elementType: "geometry",
				  stylers: [{ color: "#000000" }, { lightness: 17 }]
				}
			  ],
			  flat: [
				{
				  featureType: "administrative",
				  elementType: "labels.text.fill",
				  stylers: [{ color: "#6195a0" }]
				},
				{
				  featureType: "administrative.province",
				  elementType: "geometry.stroke",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "landscape",
				  elementType: "geometry",
				  stylers: [
					{ lightness: "0" },
					{ saturation: "0" },
					{ color: "#f5f5f2" },
					{ gamma: "1" }
				  ]
				},
				{
				  featureType: "landscape.man_made",
				  elementType: "all",
				  stylers: [{ lightness: "-3" }, { gamma: "1.00" }]
				},
				{
				  featureType: "landscape.natural.terrain",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "poi",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "poi.park",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#bae5ce" }, { visibility: "on" }]
				},
				{
				  featureType: "road",
				  elementType: "all",
				  stylers: [
					{ saturation: -100 },
					{ lightness: 45 },
					{ visibility: "simplified" }
				  ]
				},
				{
				  featureType: "road.highway",
				  elementType: "all",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "road.highway",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#fac9a9" }, { visibility: "simplified" }]
				},
				{
				  featureType: "road.highway",
				  elementType: "labels.text",
				  stylers: [{ color: "#4e4e4e" }]
				},
				{
				  featureType: "road.arterial",
				  elementType: "labels.text.fill",
				  stylers: [{ color: "#787878" }]
				},
				{
				  featureType: "road.arterial",
				  elementType: "labels.icon",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "transit",
				  elementType: "all",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "transit.station.airport",
				  elementType: "labels.icon",
				  stylers: [
					{ hue: "#0a00ff" },
					{ saturation: "-77" },
					{ gamma: "0.57" },
					{ lightness: "0" }
				  ]
				},
				{
				  featureType: "transit.station.rail",
				  elementType: "labels.text.fill",
				  stylers: [{ color: "#43321e" }]
				},
				{
				  featureType: "transit.station.rail",
				  elementType: "labels.icon",
				  stylers: [
					{ hue: "#ff6c00" },
					{ lightness: "4" },
					{ gamma: "0.75" },
					{ saturation: "-68" }
				  ]
				},
				{
				  featureType: "water",
				  elementType: "all",
				  stylers: [{ color: "#eaf6f8" }, { visibility: "on" }]
				},
				{
				  featureType: "water",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#c7eced" }]
				},
				{
				  featureType: "water",
				  elementType: "labels.text.fill",
				  stylers: [
					{ lightness: "-49" },
					{ saturation: "-53" },
					{ gamma: "0.79" }
				  ]
				}
			  ],
			  clean_cut: [
				{
				  featureType: "road",
				  elementType: "geometry",
				  stylers: [{ lightness: 100 }, { visibility: "simplified" }]
				},
				{
				  featureType: "water",
				  elementType: "geometry",
				  stylers: [{ visibility: "on" }, { color: "#C6E2FF" }]
				},
				{
				  featureType: "poi",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#C5E3BF" }]
				},
				{
				  featureType: "road",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#D1D1B8" }]
				}
			  ],
			  minimal_dark: [
				{
				  featureType: "all",
				  elementType: "all",
				  stylers: [
					{ hue: "#ff0000" },
					{ saturation: -100 },
					{ lightness: -30 }
				  ]
				},
				{
				  featureType: "all",
				  elementType: "labels.text.fill",
				  stylers: [{ color: "#ffffff" }]
				},
				{
				  featureType: "all",
				  elementType: "labels.text.stroke",
				  stylers: [{ color: "#353535" }]
				},
				{
				  featureType: "landscape",
				  elementType: "geometry",
				  stylers: [{ color: "#656565" }]
				},
				{
				  featureType: "poi",
				  elementType: "geometry.fill",
				  stylers: [{ color: "#505050" }]
				},
				{
				  featureType: "poi",
				  elementType: "geometry.stroke",
				  stylers: [{ color: "#808080" }]
				},
				{
				  featureType: "road",
				  elementType: "geometry",
				  stylers: [{ color: "#454545" }]
				},
				{
				  featureType: "transit",
				  elementType: "labels",
				  stylers: [
					{ hue: "#000000" },
					{ saturation: 100 },
					{ lightness: -40 },
					{ invert_lightness: true },
					{ gamma: 1.5 }
				  ]
				}
			  ],
			  blue_water: [
				{
				  featureType: "administrative",
				  elementType: "labels.text.fill",
				  stylers: [{ color: "#444444" }]
				},
				{
				  featureType: "landscape",
				  elementType: "all",
				  stylers: [{ color: "#f2f2f2" }]
				},
				{
				  featureType: "poi",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "road",
				  elementType: "all",
				  stylers: [{ saturation: -100 }, { lightness: 45 }]
				},
				{
				  featureType: "road.highway",
				  elementType: "all",
				  stylers: [{ visibility: "simplified" }]
				},
				{
				  featureType: "road.arterial",
				  elementType: "labels.icon",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "transit",
				  elementType: "all",
				  stylers: [{ visibility: "off" }]
				},
				{
				  featureType: "water",
				  elementType: "all",
				  stylers: [{ color: "#46bcec" }, { visibility: "on" }]
				}
			  ]
			};
			eachMapInit();
		  });
		} else {
		  eachMapInit();
		}
	  }
	}
  });
};

theme.layoutSlider = function(slider) {
  $(window).resize(function() {
	  //get sizes
	  winWidth = $(window).width();
	  var thisSlider = $(slider);

	  if (winWidth < theme.mobileBrkp) {
  		thisSlider.not(".slick-initialized").slick({
  		  slidesToShow: 1,
  		  infinite: false,
  		  dots: false,
  		  arrows: false,
  		  centerMode: true,
  		  centerPadding: "30px"
  		});
	  } else {
		//check if slick is initiated
  		if (thisSlider.hasClass("slick-initialized")) {
		  //detach slick
  		  thisSlider.slick("unslick");
  		}
	  }
	  thisSlider.on("afterChange", function(event, slick, currentSlide) {
  		$(this).find(".slick-current").addClass("js-slide-seen");
	  });
	}).resize();
};

theme.productCollSwatch = function() {
	$('.product__swatch__item').click(function() {
		var currentProduct = $(this).parents('.js-product');
		var currentProudctImage = currentProduct.find('.product__img');
		var variantProductImage = $(this).data('variant-image');
		var variantUrl = $(this).data('variant-url');

		//replace product image
		currentProudctImage.attr('data-src', variantProductImage);
		currentProudctImage.addClass('lazyload');

		//replace product variant link
		currentProduct.find('.js-product-link').attr('href', variantUrl);

		//set swatch to active
		currentProduct.find('.js-product-swatch-item').removeClass('js-active');
		$(this).addClass('js-active');

		return false;
	});
};

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

theme.ProductVideo = (function() {
  var productCarousel = $('.js-product-slider');

  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        theme.LibraryLoader.load(
          'plyrShopify',
          loadVideos.bind(this, hosts.html5)
        );
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk');
        break;
    }
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          controls: [
            'play',
            'progress',
            'mute',
            'volume',
            'play-large',
            'fullscreen'
          ],
          loop: { active: enableLooping },
          hideControlsOnPause: true,
          iconUrl:
            '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
          tooltips: { controls: false, seek: true }
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    //on media reveal
   	productCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
   		var thisSectionId = $(this).parents('.section').data('section-id');
	   	if (thisSectionId == video.sectionId) {
			if (video.container.data('slide-id') == nextSlide) {
	  			if (!Modernizr.touchevents) {
	  				if (nextSlide !== currentSlide ) {//check if is first slide and is first load
	  					setTimeout(function() {
		  					if (video.host === hosts.html5) {
						        video.player.play();
						    }
						    if (video.host === hosts.youtube && video.player.playVideo) {
						        video.player.playVideo();
						    }
					    }, 300);
	  				}
	  			}
  			}
  		}
	});
	//on media hidden
	productCarousel.on('afterChange', function(event, slick, currentSlide){
		var thisSectionId = $(this).parents('.section').data('section-id');
	   	if (thisSectionId == video.sectionId) {
	      	if (video.container.data('slide-id') != currentSlide) {
	  			if (video.host === hosts.html5) {
			        video.player.pause();
			    }
			    if (video.host === hosts.youtube && video.player.pauseVideo) {
			        video.player.pauseVideo();
			    }
	      	}
      	}
    });

    //on XR launch
	$(document).on('shopify_xr_launch', function() {
		if (video.host === hosts.html5) {
	        video.player.pause();
	    }
	    if (video.host === hosts.youtube && video.player.pauseVideo) {
	        video.player.pauseVideo();
	    }
	});
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }
    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();

theme.productMediaInit = function() {
  $('.product-single__photo__item--video').each(function(index) {
  	theme.ProductVideo.init($(this) ,$('.section--product-single').data('section-id'));
  });
  // if ($('.product-single__photo__item--model').length > 0) {
  // 	theme.ProductModel.init($('.product-single__photo__item--model'), $('.section--product-single').data('section-id'));
  // }
};

theme.homeProductMediaInit = function() {
  $('.product-featured__photo__item--video').each(function(index) {
  	theme.ProductVideo.init($(this), $(this).parents('.section').data('section-id'));
  });
  // $('.js-section__home-product').each(function(index) {
  // 	if ($(this).has('.product-featured__photo__item--model').length) {
  // 		theme.ProductModel.init($(this).find('.product-featured__photo__item--model'), $(this).children('.section').data('section-id'));
  // 	}
  // });
};

theme.normalizeReChargePrices = function(){
  var product = document.getElementById("ProductJson-1").innerHTML;
	product = JSON.parse(product || '{}');

  var customerIsMember = !!$('.js-member-discount').length

  if (customerIsMember) {
    if (product.type == 'Merchandise') {
      var discount = .8;
    } else {
      var discount = .9;
    }
  } else {
    var discount = 1;
  }
  var interval = setInterval(function(){
    if (ReCharge && ReCharge.products && ReCharge.products.length) {
      ReCharge.products.forEach(function(product){
        var variant_to_price = product.variant_to_price;

        if (variant_to_price) {
          Object.keys(variant_to_price).forEach(function(key){
            variant_to_price[key] = variant_to_price[key] * discount
          })
        }
      })
      clearInterval(interval);
    }
  }, 100)

}

theme.updateVariantPrice = function(variant, productId, sectionClass, customerIsMember, product) {

  var settings = {
    priceNumber: ".js-product-" + productId + " .js-product-price-number",
    comparePrice: ".js-product-" + productId + " .js-product-price-compare",
    rcOneTime: "#rc_price_onetime",
    memberDiscountOriginal: ".js-product-price-original"
  }

  if (customerIsMember) {
		if (product.tags.includes('no-member-discount')) {
			var discount = 1;
		} else {
			if (product.type == 'Merchandise') {
				var discount = .8;
			} else {
				var discount = .9;
			}
		}
  } else {
    var discount = 1;
  }

  // Compare at price
  if (variant.compare_at_price > variant.price) {
    var productPriceHTML = '<span class="product-' + sectionClass + "__price-number product-" + sectionClass + '__price-number--sale"><span class="money" data-lion-price-for-product-id="' + productId + '">' + Shopify.formatMoney(variant.price * discount, theme.money_format) + "</span></span>"
    var comparePriceHTML = '<s class="product-' + sectionClass + '__price-compare"><span class="money">' + Shopify.formatMoney(variant.compare_at_price, theme.money_format) + "</span></s>"

    // non subscription product price
    $(settings.priceNumber).html(productPriceHTML);
    $(settings.comparePrice).html(comparePriceHTML);

  } else if (customerIsMember) {
    $(settings.memberDiscountOriginal).html(Shopify.formatMoney(variant.price, theme.money_format));

  } else {
    var productPriceHTML = '<span class="product-' + sectionClass + '__price-number"><span class="money" data-lion-price-for-product-id="' + productId + '">' + Shopify.formatMoney(variant.price * discount, theme.money_format) + "</span></span>"

    $(settings.priceNumber).html(productPriceHTML);
    $(settings.comparePrice).empty();
  }


  // Subscription / ReCharge Products
  var $oneTimePrice = $(settings.rcOneTime);
  if ($oneTimePrice.length) {
    $oneTimePrice.text(Shopify.formatMoney(variant.price * discount, theme.money_format));
  }
}

theme.updateProductImages = function(variant, productId, sectionClass){
  //slider functions
	var thisSlider = $(".js-product-" + productId + " .js-product-slider");

  function checkSlick(slideToGo) {
	  //move slider to variant after slick is init
	  var interval = setInterval(function() {
  		if (thisSlider.hasClass("slick-initialized")) {
  		  thisSlider.slick("slickGoTo", slideToGo);
  		  clearInterval(interval);
  		}
	  }, 100);
	}

	if (variant.featured_image !== null) {
		if (variant.featured_image.variant_ids.length > 0) {
			var mediaId = variant.featured_media.id;
			var slide = $(".js-product-" + productId + " .product-" + sectionClass + "__photo__item[data-media-id*=" + variant.featured_media.id + "]");
			var slideId = slide.attr("data-slide-id");

			checkSlick(slideId);
		} else {
		  checkSlick(0);
		}
	}
}

theme.productSelect = function(sectionId, cssClass, historyState) {

  var productObj = document.getElementById("ProductJson-" + sectionId).innerHTML;
	  productObj = JSON.parse(productObj || '{}');

  var sectionClass = cssClass;

  var selectCallback = function(variant, selector) {
	var productId = productObj.id;
	sectionClass = sectionClass;

  var customerIsMember = !!$('.js-member-discount').length

	document.dispatchEvent(
	  new CustomEvent("venue:variant:update", {
		bubbles: true,
		detail: { product: productObj, variant: variant, cssClass: cssClass }
	  })
	);

	// Price functions
	if (variant) {

	  // Selected a valid variant that is available.
    theme.updateVariantPrice(variant, productId, sectionClass, customerIsMember, productObj);

	  if (variant.available) {
      // Enabling add to cart button.
  		$(".js-product-" + productId + " .js-product-add")
  		  .removeClass("disabled")
  		  .prop("disabled", false)
  		  .find(".js-product-add-text")
  		  .text(theme.t.add_to_cart);
  		$(".js-product-" + productId + " .js-product-buttons").removeClass(
  		  "product-single__add--sold"
  		);
	  } else {
      // Variant is sold out.
  		$(".js-product-" + productId + " .js-product-add")
  		  .addClass("disabled")
  		  .prop("disabled", true)
  		  .find(".js-product-add-text")
  		  .text(theme.t.sold_out);

  		$(".js-product-" + productId + " .js-product-buttons").addClass("product-single__add--sold");
	  }
	} else {
	  // variant doesn't exist.

	  // Price and button
	  $(".js-product-" + productId + " .js-product-price-number").html('&nbsp;');
	  $(".js-product-" + productId + " .js-product-price-compare").empty();
	  $(".js-product-" + productId + " .js-product-add")
  		.addClass("disabled")
  		.prop("disabled", true)
  		.find(".js-product-add-text")
  		.text(theme.t.unavailable);
	}


  theme.updateProductImages(variant, productId, sectionClass);

  document.dispatchEvent(
    	new CustomEvent("venue:variant:updated", {
    		bubbles: true,
    		detail: { product: productObj, variant: variant, cssClass: cssClass }
  	  })
  	);
  };

  $("[name='purchase_type']").on('change', function(e){
    var value = $(this).val();
    if (value === "onetime") {
      $('.js-why-subscribe').addClass('hide')
    } else {
      $('.js-why-subscribe').removeClass('hide')
    }
  })

  //SWATCH functions
  //match swatch to dropdown
  $('.js-product-single-swatch :radio').change(function() {

  	var optionIndex = $(this).closest('.js-product-single-swatch').attr('data-option-index');
  	var optionValue = $(this).val();

  	$(this)
  	  .closest('form')
  	  .find('.single-option-selector')
  	  .eq(optionIndex - 1)
  	  .val(optionValue)
  	  .change();

  	//update sub title text
  	var value = $(this).val();
  	var sub_title = $(this).parents('.js-product-single-swatch').find('.js-swatch-variant-title');
  	sub_title.text(value);
  });
  //initial color title text
  $('.js-swatch-variant-title').text($('.js-swatch-color-item :radio:checked').val());

  //check if product selected
  if (productObj.onboarding !== true) {
  	new Shopify.OptionSelectors("productSelect-" + sectionId, {
  	  product: productObj,
  	  onVariantSelected: selectCallback,
  	  enableHistoryState: historyState
  	});

  	if (productObj.options.length == 1 && productObj.options[0] != "Title") {
  	  // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
  	  $(".js-product-" + productObj.id + " .selector-wrapper:eq(0)").prepend(
  		'<label for="productSelect-option-0">' +
  		  productObj.options[0] +
  		  "</label>"
  	  );
  	}
  	if (productObj.variants.length == 1 && productObj.variants[0].title.indexOf("Default") > -1) {
  	  // Hide selectors if we only have 1 variant and its title contains 'Default'.
  	  $(".js-product-" + productObj.id + " .selector-wrapper").hide();
  	  $(".js-product-" + productObj.id + " .swatch").hide();
  	}
  }
};

if (window.location.href.indexOf("/products") > -1) {
	theme.productSelect('1','single', true);
}

theme.eventFeed = function(apiKey, templateId, anchorId, sectionId) {
  var url =
	"https://www.eventbriteapi.com/v3/users/me/owned_events/?token=" +
	apiKey +
	"&expand=venue&status=live";

  $.getJSON(url, function(data) {
	var template = $(templateId).html();
	var compile = Handlebars.compile(template)(data);

	//compile and append tempalte with data
	$(anchorId).append(compile);
	//slider dunction
	theme.layoutSlider(".js-layout-slider-" + sectionId);

	//scrollreveal
	if ($("body").data("anim-load")) {
	  sr.reveal(".section--" + sectionId + " .section__link", { distance: 0 });
	  sr.reveal(".section--" + sectionId + " .home-event__item", {
		interval: theme.intervalValue
	  });
	}
  });
  //format time helper
  Handlebars.registerHelper("formatDate", function(date) {
	return fecha.format(new Date(date), "ddd, DD MMM, HH:mm");
  });
  // string contains helper
	Handlebars.registerHelper('contains', function(needle, haystack, options) {
		needle = Handlebars.escapeExpression(needle);
		haystack = Handlebars.escapeExpression(haystack);
		return (haystack.indexOf(needle) > -1) ? options.fn(this) : options.inverse(this);
 	});
  //limit loop helper
  Handlebars.registerHelper("each_upto", function(ary, max, options) {
	if (!ary || ary.length === 0) return options.inverse(this);
	var result = [];
	for (var i = 0; i < max && i < ary.length; ++i)
	  result.push(options.fn(ary[i]));
	return result.join("");
  });
};

//home carousel functions & video backgound
theme.homeMainCarousel = function() {
  var carousels = $(".js-home-carousel");
  var currWinWidth = $(window).width();

  var mobileCond = currWinWidth >= 1;

  //slick carousel functions and init
  carousels.each(function() {
	var carousel = $(this);

	carousel.on("init", function(event, slick) {
	  //check if this carousel has videos
	  if ($(this).find(".js-home-carousel-video").length) {
		if (mobileCond) {
		  var thisCarousel = $(this);
		  //check if youtube API is loaded
		  if (typeof YT === "undefined") {
			// insert youtube iframe API
			$.getScript("https://www.youtube.com/iframe_api")
			  //after loaded
			  .done(function() {
				var interval = setInterval(function() {
				  //check if YT is function and loop if not
				  if ($.isFunction(YT.Player)) {
					loadVideos(thisCarousel);
					clearInterval(interval);
				  }
				}, 100);
			  });
		  } else {
			loadVideos(thisCarousel);
		  }
		}
	  }

	  //content loading classes
	  $(this)
		.find(".slick-active")
		.addClass("js-slide-active");
	});

	carousel.on("afterChange", function(event, slick) {
	  if (mobileCond) {
		if ($(this).find(".js-home-carousel-video").length) {
		  if ($(this).find(".slick-active .js-home-carousel-video").length) {
			var dataPlayerId = $(this)
			  .find(".slick-active .js-home-carousel-video-data")
			  .attr("data-player-id");

			if (window[dataPlayerId].B) {
			  //check if element is ready
			  window[dataPlayerId].playVideo();
			} else {
			  setTimeout(function() {
				window[dataPlayerId].playVideo();
			  }, 1000);
			}

			var thisVideo = $(this).find(
			  ".slick-active .js-home-carousel-video"
			);
			//ading timeout so video cover waits for youtube to initiate loading
			setTimeout(function() {
			  thisVideo.addClass("js-loaded");
			}, 800);
		  }
		}
	  }

	  //content loading classes
	  $(this)
		.find(".slick-slide")
		.removeClass("js-slide-active");
	  $(this)
		.find(".slick-active")
		.addClass("js-slide-active");
	});

	carousel.not(".slick-initialized").slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  infinite: true,
	  dots: true,
	  fade: true,
	  cssEase: "linear",
	  prevArrow:
		'<div class="home-carousel__nav home-carousel__nav--prev"><i class="icon icon--left-t"></i></div>',
	  nextArrow:
		'<div class="home-carousel__nav home-carousel__nav--next"><i class="icon icon--right-t"></i></div>'
	});

	//checking for adaptive height when loading for smoother first view
	for (var i = 0; i < 10; i++) {
	  setTimeout(function() {
		$('.js-home-carousel').slick('setPosition');
	  }, 250 * i);
	}
  });

  function loadVideos(thisCarousel) {
	var players = $(thisCarousel).find(".js-home-carousel-video-data");

	function onReadyVideo(event) {
	  event.target.mute();
	  theme.videoSize(event.target.f);

	  //check if this slide is active and play video if so
	  if (
		$(event.target.f)
		  .parents(".slick-slide")
		  .hasClass("slick-active")
	  ) {
		event.target.playVideo();
		//ading timeout so video cover waits for youtube to start playing
		setTimeout(function() {
		  $(event.target.f)
			.parent()
			.addClass("js-loaded");
		}, 800);
	  }
	}

	function onChangeVideo(event) {
	  if (event.data === YT.PlayerState.ENDED) {
		//when video ends - repeat
		event.target.playVideo();
	  }
	}

	for (var i = 0; i < players.length; i++) {
	  window[players[i].getAttribute("data-player-id")] = new YT.Player(
		players[i],
		{
		  videoId: players[i].getAttribute("data-video-id"),
		  playerVars: {
			iv_load_policy: 3,
			modestbranding: 1,
			playsinline: 1,
			cc_load_policy: 0,
			fs: 0,
			autoplay: 1,
			mute: 1,
			controls: 0,
			showinfo: 0,
			wmode: "opaque",
			quality: 'hd720',
			branding: 0,
			autohide: 0,
			rel: 0
		  },
		  events: {
			onReady: onReadyVideo,
			onStateChange: onChangeVideo
		  }
		}
	  );
	}
  }

  //recalcluate all iframe sizes on browser resize
  var videoResizeTimer;
  $(window).resize(function() {
	winWidth = $(window).width();
	  clearTimeout(videoResizeTimer);
	  videoResizeTimer = setTimeout(function() {
		theme.videoSize($(".js-home-carousel-video-data"));
	  }, 500);
  });
};

theme.videoSize = function(video) {
  //set elems
  var iframe = $(video);

  //find video size
  var origHeight = iframe.attr("height");
  var origWidth = iframe.attr("width");

  //find element width and caclulate new height
  var parentHeigt = iframe.parent().height();
  var parentWidth = iframe.parent().width();

  //calc height and width based on original ratio
  var newHeight = (parentWidth / origWidth) * origHeight;
  var newWidth = (parentHeigt / origHeight) * origWidth;

  //check if video ratio fits with carousel container and add css settings
  if (parentHeigt < newHeight) {
	iframe.css({
	  width: parentWidth + "px",
	  height: newHeight + 120 + "px",
	  top: (parentHeigt - newHeight) / 2 - 60 + "px",
	  left: 0
	});
  } else {
	iframe.css({
	  width: newWidth + "px",
	  height: parentHeigt + 120 + "px",
	  left: (parentWidth - newWidth) / 2 + "px",
	  top: '-60px'
	});
  }
};

//home video gallery
theme.homeVideoGallery = function() {
  //load in Shopify Plyr styles
  theme.LibraryLoader.load('plyrShopifyStyles');

  function vimeoThumbs() {
	//iteration for all thumbs while waiting for ajax to complete
	var i = 0;
	function next() {
	  if (i < $(".js-vimeo-thumb").length) {
		thisThumb = $(".js-vimeo-thumb")[i];
		var vimeoID = $(thisThumb).attr("data-video-id");

		$.ajax({
		  url: "https://vimeo.com/api/v2/video/" + vimeoID + ".json",
		  dataType: "json",
		  complete: function(data) {
			$(thisThumb).attr(
			  "data-bgset",
			  data.responseJSON[0].thumbnail_medium
			);

			i++;
			next();
		  }
		});
	  }
	}
	// kick off the first thumb iteration
	next();

	//placeholder thumb
	if ($(".js-vimeo-placeholder").length > 0) {
	  var vimeoID = $(".js-vimeo-placeholder").attr("data-video-id");

	  $.ajax({
		url: "https://vimeo.com/api/v2/video/" + vimeoID + ".json",
		dataType: "json",
		success: function(data) {
		  var img = data[0].thumbnail_large;
		  var newImg = img.replace("640", "1280");
		  $(".js-vimeo-placeholder").attr("data-bgset", newImg);
		}
	  });
	}
  }
  vimeoThumbs(); //run

  //init player plugin after lazy loaded iframes
  homePlayers = [];
  var lazyVideo = new LazyLoad({
	elements_selector: ".js-lazy-iframe",

	callback_set: function(el) {
	  var videoId = $(el)
		.parent()
		.attr("id");

	  //setup each player with unique var
	  window[videoId] = new Plyr(".js-home-video-player", {
          controls: [
            'play',
            'progress',
            'mute',
            'volume',
            'play-large',
            'fullscreen'
          ],
          loop: { active: false },
          hideControlsOnPause: true,
          iconUrl:
            '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
          tooltips: { controls: false, seek: true }
	  });

	  //array of all players for mass functions
	  homePlayers.push(window[videoId]);
	}
  });

  //placeholder click
  $(".js-home-video-placeholder-trigger").click(function(e) {
	e.preventDefault();

	var triggerTarget = $(this).attr("href");
	var triggerId = $(this)
	  .attr("href")
	  .replace(/#/, "");

	//hide placeholder
	$(this)
	  .parent(".js-home-video-placeholder")
	  .addClass("js-hidden");

	//pause all videos if playing
	homePlayers.forEach(function(instance) {
	  instance.pause();
	});

	//start video
	window["home_player_" + triggerId].play();
  });

  //thumbs click
  $(".js-home-video-trigger").click(function(e) {
	e.preventDefault();

	var triggerTarget =
	  "#js-home-video-" +
	  $(this)
		.attr("href")
		.replace(/#/, "");
	var triggerId = $(this)
	  .attr("href")
	  .replace(/#/, "");
	var sectionPlaceholder = $(this)
	  .parents(".home-video")
	  .find(".js-home-video-placeholder");

	//hide placeholder
	sectionPlaceholder.addClass("js-hidden");

	//remove and add active class
	$(this)
	  .parents(".home-video")
	  .find(".js-home-video")
	  .removeClass("js-active");
	$(triggerTarget).addClass("js-active");

	//pause all videos
	homePlayers.forEach(function(instance) {
	  instance.pause();
	});

	//pause on second click and play function
	if (
	  $(this)
		.parent()
		.hasClass("js-paused")
	) {
	  window["home_player_" + triggerId].play();
	  $(this)
		.parent()
		.removeClass("js-paused");
	} else if (
	  $(this)
		.parent()
		.hasClass("js-active")
	) {
	  $(this)
		.parent()
		.addClass("js-paused");
	} else {
	  window["home_player_" + triggerId].play();
	}

	//set correct thumb to active
	$(".js-home-video-trigger")
	  .parent()
	  .removeClass("js-active");
	$(".js-home-video-trigger")
	  .parent()
	  .removeClass("js-init");
	$(this)
	  .parent()
	  .addClass("js-active");
  });
};

theme.masonryLayout = function() {
  // Masonry layout init
  // Loading images
  $(".o-layout--masonry")
	.imagesLoaded()
	.always(function(instance) {
	  $(".o-layout--masonry").masonry({
		itemSelector: ".o-layout__item",
		transitionDuration: 0
	  });

	  //reset scroll reveal geometry
	  if ($("body").data("anim-load")) {
		sr.delegate();
	  }
	})
	// Run masonry while loading images
	.progress(function(instance, image) {
	  $(".o-layout--masonry").masonry({
		itemSelector: ".o-layout__item",
		transitionDuration: 0
	  });

	  //reset scroll reveal geometry
	  if ($("body").data("anim-load")) {
		sr.delegate();
	  }
	});
};

theme.animFade = function() {
  if ($("body").data("anim-fade")) {
	// add class to stop transition to non navigational links
	$(
	  'a[href^="#"], a[target="_blank"], a[href^="mailto:"], a[href^="tel:"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
	).each(function() {
	  $(this).addClass("js-no-transition");
	});
	//fix for safari and firefox back button issues
	if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) || !!navigator.userAgent.match(/Firefox\/([0-9]+)\./)) {
	  $("a").on("click", function() {
		window.setTimeout(function() {
		  $("body").removeClass("js-theme-unloading");
		}, 1200);
	  });
	}

	$(
	  "a:not(.js-no-transition, .js-header-sub-link-a, .js-header-sub-t-a)"
	).bind("click", function(e) {
	  if (e.metaKey) return true;
	  e.preventDefault();
	  //close all popups
	  $.magnificPopup.close();
	  //add class for unloading
	  $("body").addClass("js-theme-unloading");
	  //redirect
	  var src = $(this).attr("href");
	  window.setTimeout(function() {
		location.href = src;
	  }, 50);
	});
  }
};

theme.animScroll = function() {
  if ($("body").data("anim-load")) {
	theme.intervalStyle = {};
	if ($("body").data("anim-interval-style") == "fade_down") {
	  theme.intervalStyle = "-20px";
	} else if ($("body").data("anim-interval-style") == "fade_up") {
	  theme.intervalStyle = "20px";
	} else {
	  theme.intervalStyle = "0";
	}

	theme.intervalValue = {};
	if ($("body").data("anim-interval")) {
	  theme.intervalValue = 200;
	} else {
	  theme.intervalValue = 0;
	}

	var config = {
	  viewFactor: 0.1,
	  duration: 1000,
	  distance: theme.intervalStyle,
	  scale: 1,
	  delay: 0,
	  mobile: true,
	  useDelay: "once",
	  beforeReveal: function myCallback(el) {
			$(el).addClass("js-sr-loaded");
	  }
	};

	window.sr = new ScrollReveal(config);

	//global data trigger
	sr.reveal(".js-animation-fadeIn-trigger", { distance: 0 });
	sr.reveal(".js-animation-fadeDown-trigger", {
		interval: theme.intervalValue
	});

	//elements
	sr.reveal(".section__title", { distance: "5px" });
	sr.reveal(".section__title-desc", { distance: 0, delay: 300 });
	sr.reveal(".newsletter, .section__link, .account", { distance: 0 });
	sr.reveal(".product-top, .collection-list__item", {
	  interval: theme.intervalValue
	});

	//cart
	sr.reveal(".cart .section__title", { distance: "20px" });
	sr.reveal(".cart__content", { distance: 0, delay: 500 });

	//search
	sr.reveal(".search-page .section__title", { distance: "20px" });
	sr.reveal(".search-page__form, .search-page-pagination", {
	  distance: 0,
	  delay: 200
	});
	sr.reveal(".search-page .product-top, .search-page__other-item", {
	  interval: theme.intervalValue,
	  delay: 0
	});

	//blog
	sr.reveal(".blog", { delay: 300, interval: theme.intervalValue });
	sr.reveal(".blog-page__tags, .blog-pagination", {
	  distance: 0,
	  delay: 300
	});
	sr.reveal(".blog-page .section__title", { distance: "20px" });

	//article
	sr.reveal(".article .section__title", { distance: "20px" });
	sr.reveal(".article__date", { distance: "-10px", delay: 500 });
	sr.reveal(".article__featured-media, .article__content", {
	  distance: 0,
	  delay: 200
	});
	sr.reveal(".article__meta, .article-paginate", { distance: 0 });

	//collection page
	sr.reveal(".collection__header-info__title", { distance: "20px" });
	sr.reveal(".collection .product-top", { interval: theme.intervalValue });
	sr.reveal(
	  ".collection__header-media, .collection__header-info__text, .collection-main__sort, .collection-empty, .collection-pagination",
	  { distance: 0, delay: 200 }
	);

	//collection list
	sr.reveal(".list-collections .section__title", { distance: "20px" });
	sr.reveal(".list-collections .collection-list__item", {
	  interval: theme.intervalValue,
	  delay: 500
	});

	//product page
	sr.reveal(".product-single__title-text", { distance: "20px" });
	sr.reveal(".product-single__title-desc, .breadcrumb, .product-single__photos, .product-single__content, .product-single--minimal .product-single__content-text", { distance: 0, delay: 300, useDelay: "onload" });

	//page
	sr.reveal(".page .section__title", { distance: "20px" });
	sr.reveal(".faq__cta", { distance: 0, delay: 300 });
	sr.reveal(".faq__search", { distance: 0, delay: 300 });
	sr.reveal(".faq__accordion", { distance: 0, delay: 500 });
	sr.reveal(".faq__category__title", { distance: 0 });
	sr.reveal(".page__contact-form", { distance: 0, delay: 200 });

	//sections
	sr.reveal(".home-carousel .section__title", { distance: 0 });
	sr.reveal(".home-image-grid__item", { interval: theme.intervalValue });
	sr.reveal(".home-promo__box");
	sr.reveal(".home-intro", { distance: 0 });
	sr.reveal(
	  ".home-intro__media, .home-intro__text, .home-intro__video, .home-intro__link-wrap"
	);
	sr.reveal(".home-logo-list__items", { distance: 0 });
	sr.reveal(".home-testimonials", { distance: 0 });

	sr.reveal(".product-featured__photo-wrapper", { distance: 0, delay: 500 });
	sr.reveal(".home-event__item", { interval: theme.intervalValue }); //aslo in eventFeed secion for ajax
	sr.reveal(".home-delivery", { distance: 0 });
	sr.reveal(".home-delivery__content", { distance: theme.intervalStyle });
	sr.reveal(".home-map__items");
	sr.reveal(".home-rich-text__content", { distance: 0, delay: 500 });
	sr.reveal(".home-inline__item", { interval: theme.intervalValue });
	sr.reveal(".home-video__stage, .home-video__items", { distance: 0 });
	sr.reveal(".home-custom__item", { interval: theme.intervalValue });
	sr.reveal(".home-html", { distance: 0 });
  }
};

theme.thumbsCarousel = function() {
  	$(".js-section__product-single .js-product-slider").not(".slick-initialized").each( function() {
      var slickSettings = {
        focusOnSelect: true,
        accessibility: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: true,
        swipe: true,
        fade: true,
        adaptiveHeight: true,
        speed: 300,
        cssEase: "ease",
        lazyLoad: "progressive",
        prevArrow: '<div class="product-single__photo__nav__item product-single__photo__nav__item--prev"><i class="icon icon--left-l"></i></div>',
        nextArrow: '<div class="product-single__photo__nav__item product-single__photo__nav__item--next"><i class="icon icon--right-l"></i></div>',
        asNavFor: $(this).parent().find('.js-product-single-thumbs'),
        // appendDots: $(this).parent().find('.js-product-slider-nav-dots'),
        // responsive: [{
        //     breakpoint: 768,
        //       settings: {
        //         appendArrows: $(this).parent().find('.js-product-slider-nav')
        //       }
        //  }]
      }

      var thumbSettings = {
        focusOnSelect: true,
        accessibility: true,
        slidesToShow: 9,
        slidesToScroll: 1,
        infinite: false,
        vertical: true,
        lazyLoad: "progressive",
        asNavFor: $(this).parent().find('.js-product-slider')
      }

  		$(this).slick(slickSettings)
  		//calc height for single product classic view slideshow
  		.on("setPosition", function(event, slick) {
  			if ($(".product-single").hasClass("product-single--classic")) {
  			  if ($(".js-product-bg").hasClass("js-product-bg--full")) {
    				heightFraction = 1;
  			  } else {
    				heightFraction = 0.55;
  			  }

  			  var photoHeight = $(".js-product-slider").find(".slick-list").height();

  			  var thumbsHeight = 0;

          if ($(".js-product-slider-nav").find(".slick-dots").length) {
    				thumbsHeight = $(".js-product-slider-nav").find(".slick-dots").outerHeight(true);
  			  }

  			  var breadcrumbHeight = 0;
  			  if ($('.js-breadcrumb').length) {
  			  	breadcrumbHeight = $('.js-breadcrumb').outerHeight(true);
  			  }

  			  var viewInSpaceBtnHeight = 0;
  			  if ($('.js-product-view-in-space-btn').length > 0 && !$('.js-product-view-in-space-btn').is('[data-shopify-xr-hidden]')) {
  			  	viewInSpaceBtnHeight = $(".js-product-view-in-space-btn").outerHeight(true);
  			  }

  			  $(".js-product-bg").css(
  				"height",
  				  photoHeight *
  				  heightFraction +
  				  thumbsHeight +
  				  breadcrumbHeight +
  				  viewInSpaceBtnHeight +
  				  60 +
  				  "px"
  			  );
  			}
  		});

      $(this).parent().find('.js-product-single-thumbs').slick(thumbSettings);

    });


  //checking for adaptive height when loading for smoother first view
	for (var i = 0; i < 15; i++) {
	  setTimeout(function() {
  		$('.js-product-slider').slick('setPosition');
	  }, 250 * i);
	}
};

theme.logoCarousel = function() {

  function logoCarouselInitFull(carousel) {
  	carousel.not(".slick-initialized").slick({
  	  slidesToShow: slideCount,
  	  slidesToScroll: slideCount,
  	  arrows: false,
  	  dots: false,
  	  fade: false,
  	  adaptiveHeight: false,
  	  speed: 300,
  	  cssEase: "ease",
  	  responsive: [
    		{
    		  breakpoint: theme.mobileBrkp,
    		  settings: {
      			swipeToSlide: true,
      			slidesToShow: 2,
      			slidesToScroll: 1
    		  }
    		}
  	  ]
  	});
  }

  function logoCarouselInitDesk(carousel) {
  	carousel.not(".slick-initialized").slick({
  	  slidesToShow: slideCount,
  	  slidesToScroll: slideCount,
  	  arrows: false,
  	  dots: false,
  	  fade: false,
  	  adaptiveHeight: false,
  	  speed: 300,
  	  cssEase: "ease"
  	});
  }

  function logoCarouselInitMobile(carousel) {
  	carousel.not(".slick-initialized").slick({
  	  slidesToShow: 2,
  	  slidesToScroll: 1,
  	  swipeToSlide: true,
  	  variableWidth: true,
  	  arrows: false,
  	  dots: false,
  	  fade: false,
  	  adaptiveHeight: false,
  	  speed: 300,
  	  cssEase: "ease"
  	});
  }

  $(window).resize(function() {
	  //get sizes
	  winWidth = $(window).width();

	  var carousels = $(".js-home-logo-list-carousel");

	  //slick carousel functions and init
	  carousels.each(function() {
  		carousel = $(this);

  		slideCount = carousel.data("carouselCount");

  		desktop = carousel.data("carouselDesktop");
  		mobile = carousel.data("carouselMobile");

  		if (desktop && mobile) {
  		  logoCarouselInitFull(carousel, slideCount);
  		} else if (desktop) {
        if (winWidth >= theme.mobileBrkp) {
  			logoCarouselInitDesk(carousel, slideCount);
  		  } else {
  			//check if slick is initiated
  			if (carousel.hasClass("slick-initialized")) {
  			  //detach slick
  			  carousel.slick("unslick");
  			}
		  }
		} else if (mobile) {
  		  if (winWidth < theme.mobileBrkp) {
  			logoCarouselInitMobile(carousel);
  		  } else {
  			//check if slick is initiated
  			if (carousel.hasClass("slick-initialized")) {
    			  //detach slick
    			  carousel.slick("unslick");
    			}
  		  }
  		}
	  });
	})
	.resize();
};

theme.testimonialsCarousel = function() {


  function testimonialsCarouselInit(carousel) {
    $(carousel).on('click', '.js-testimonial-arrow', function(){
      if ($(this).hasClass('slick-next')) {
        carousel.slick('slickNext');
      } else {
        carousel.slick('slickPrev');
      }
    })

    var config = {
  	  slidesToShow: 1,
  	  slidesToScroll: 1,
  	  arrows: true,
  	  dots: false,
  	  fade: false,
  	  adaptiveHeight: false,
  	  speed: 300,
      fade: true,
  	  cssEase: "ease",
  	  lazyLoad: "progressive",
      appendArrows: '.js-testimonial-arrows',
  	  prevArrow: '<div class="home-testimonials-carousel__nav js-testimonial-arrow home-testimonials-carousel__nav--prev slick-prev"><i class="icon icon--left-l"></i></div>',
  	  nextArrow: '<div class="home-testimonials-carousel__nav js-testimonial-arrow home-testimonials-carousel__nav--next slick-next"><i class="icon icon--right-l"></i></div>'
  	}

    if (window.screen.availWidth < 769) {
      config.autoplay = false;
    }

  	carousel.not(".slick-initialized").slick(config);
  }

  $(window).resize(function() {
	  //get sizes
	  winWidth = $(window).width();

	  var carousels = $(".js-home-testimonials-carousel");

	  //slick carousel functions and init
	  carousels.each(function() {
		carousel = $(this);

		desktop = carousel.data("carouselDesktop");
		mobile = carousel.data("carouselMobile");

		if (desktop && mobile) {
		  testimonialsCarouselInit(carousel);
		} else if (desktop) {
		  if (winWidth >= theme.mobileBrkp) {
			testimonialsCarouselInit(carousel);
		  } else {
			//check if slick is initiated
			if (carousel.hasClass("slick-initialized")) {
			  //detach slick
			  carousel.slick("unslick");
			}
		  }
		} else if (mobile) {
		  if (winWidth < theme.mobileBrkp) {
			testimonialsCarouselInit(carousel);
		  } else {
			//check if slick is initiated
			if (carousel.hasClass("slick-initialized")) {
			  //detach slick
			  carousel.slick("unslick");
			}
		  }
		}
	  });
	})
	.resize();
};

theme.headerScrollUp = function() {
	function hasScrolled() {
		var st = $(this).scrollTop();

		// Make sure to scroll more than delta
		if(Math.abs(lastScrollTop - st) <= delta)
			return;

		// If scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight){
			// Scroll Down
			$('.js-header').css({
			  '-webkit-transform' : 'translateY(-' + $('.js-header').outerHeight() + 'px)',
			  '-moz-transform'    : 'translateY(-' + $('.js-header').outerHeight() + 'px)',
			  'transform'         : 'translateY(-' + $('.js-header').outerHeight() + 'px)'
			});

			$(body).removeClass('header-down').addClass('header-up');

			$('.js-header').trigger('resize');

		} else {
			// Scroll Up
			if(st + $(window).height() < $(document).height()) {
				$('.js-header').css({
				  '-webkit-transform' : 'translateY(' + 0 + ')',
				  '-moz-transform'    : 'translateY(' + 0 + ')',
				  'transform'         : 'translateY(' + 0 + ')'
				});
			}

			$(body).removeClass('header-up').addClass('header-down');

		  	$('.js-header').trigger('resize');
		  	//recalulating stikcy position for in case announcment is on
		  	if (st < 100) {
		  		setTimeout(function() {
					$('.js-header').trigger('resize');
				}, 250);
		  	}
		}
		lastScrollTop = st;
	}

	if ($(".js-header").hasClass("js-header-scroll")) {
		// Hide Header on on scroll down
		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;
		var navbarHeight = $('.js-header').outerHeight();

		$(window).scroll(function(event){
			didScroll = true;
		});

		setInterval(function() {
			if ($(".js-header").hasClass("js-header-scroll")) {
				if (didScroll) {
					hasScrolled();
					didScroll = false;
				}
			}
		}, 250);
	}
};

theme.scrollToFixedFaq = function() {
	//sticky faq categories
	$(".js-faq-categories").scrollToFixed({
		marginTop: function() {
			if ($(".js-header").hasClass("js-header-scroll")) {
				if ($("body").hasClass("header-down")) {
					prodBoxMargins = $(".js-header").outerHeight() + 18;
				} else {
					prodBoxMargins = 18;
				}
			} else if ($(".js-header").hasClass("js-header-sticky")) {
				prodBoxMargins = $(".js-header").outerHeight() + 18;
			} else {
				prodBoxMargins = 18;
			}
			return prodBoxMargins;
		},
		postFixed: function() {
			$(this).addClass('scroll-to-fixed-unfixed');
		},
		fixed: function() {
			$(this).removeClass('scroll-to-fixed-unfixed');
		},
		limit: function() {
			var limit =
				$(".js-faq-page").height() +
				$(".js-faq-page").offset().top -
				$(".js-faq-categories").outerHeight() +
				15; //adjusting for page margins
			return limit;
		},
		zIndex: 10,
		minWidth: theme.tabletBrkp,
		spacerClass: 'faq-categories-spacer'
	});
};
theme.scrollToFixedHeader = function() {
  //sticky header
  //always attaching scrollToFixed for touch event hover outside
  $(".js-header").scrollToFixed({
	zIndex: 11,
	spacerClass: 'header-fixed-spacer'
  });
  //detaching if no sticky class found
  if (!$(".js-header").hasClass("js-header-sticky")) {
	$(".js-header").trigger("detach.ScrollToFixed");
  }
  //sticky header border trigger
  $(window).scroll(function() {
	if ($(window).scrollTop() >= 80) {
	  $(".js-header-sticky").addClass("js-header-sticky--fixed");
	} else {
	  $(".js-header-sticky").removeClass("js-header-sticky--fixed");
	}
  });
};

theme.accordion = function() {
  var item = $(".js-accordion-info");
  var trigger = $(".js-accordion-trigger");
 // var items = item.hide(); //hide all items
  var activeClass = "js-active";

  trigger.click(function() {
	var thisItem = $(this).attr("href");

	//recalculate single product fixed box position on accordion changes
	//added delay to wait for accordion to finish animating
	setTimeout(function() {
	  $(".js-product-single-box").trigger("resize");
	}, 400);

	//review stars scroll and open
	if ($(this).hasClass("js-accordion-scroll")) {
	  var outsideAccordion = $(".js-accordion").find(
		"[href='" + $(this).attr("href") + "']"
	  );

	  //check if sticky header and set correct offset
	  if ($(".js-header").hasClass("js-header-sticky")) {
		scrollOffset = $(".js-header").outerHeight() + 18;
	  } else {
		scrollOffset = 18;
	  }

	  //scroll
	  $("html,body").animate(
		{
		  scrollTop: outsideAccordion.offset().top - scrollOffset
		},
		800
	  );

	  //open accordion
	  $(thisItem)
		.addClass(activeClass)
		.stop()
		.slideDown();
	  outsideAccordion.addClass(activeClass);

	  return false;
	}

	//check if clicked is active
	if ($(thisItem).hasClass(activeClass)) {
	  //close current item
	  $(this).removeClass(activeClass);
	  $(thisItem)
		.removeClass(activeClass)
		.stop()
		.slideUp();
	} else {
	  //open and activate this item
	  $(thisItem)
		.addClass(activeClass)
		.stop()
		.slideDown();
	  $(this).addClass(activeClass);
	}

	return false;
  });

  //FAQ page autocomplete with accordion scroll
  if (typeof faq_items != "undefined") {
	$(".js-faq-autocomplete").autocomplete({
	  lookup: faq_items,
	  lookupFilter: function(suggestion, query, queryLowerCase) {
		var content = suggestion.content.toLowerCase(),
		  value = suggestion.value.toLowerCase();

		return (
		  content.indexOf(queryLowerCase) > -1 ||
		  value.indexOf(queryLowerCase) > -1
		);
	  },
	  onSelect: function(suggestion) {
		//check if sticky header and set correct offset
		if ($(".js-header").hasClass("js-header-sticky")) {
		  scrollOffset = $(".js-header").outerHeight() + 18;
		} else {
		  scrollOffset = 18;
		}

		//scroll
		$("html,body").animate(
		  {
			scrollTop:
			  $(".js-accordion")
				.find("[href='#" + suggestion.data + "']")
				.offset().top - scrollOffset
		  },
		  800
		);

		setTimeout(function() {
		  //open accordion
		  $("#" + suggestion.data)
			.addClass(activeClass)
			.stop()
			.slideDown();
		  $(".js-accordion")
			.find("[href='#" + suggestion.data + "']")
			.addClass(activeClass);
		}, 800);

		$(this).val('');
	  }
	});
	//disable browser autocomplete
	$(".js-faq-autocomplete").disableAutoFill();
  }
};

//animated scroll to div ID
theme.scrollToDiv = function() {
  $(".js-scroll-id").click(function(e) {
	var thisId = $(this).attr("href");

	//check for the offset
	if ($(".js-header").hasClass("js-header-sticky")) {
	  scrollOffset = $(".js-header").outerHeight() + 18;
	} else {
	  scrollOffset = 18;
	}

	//scroll
	$("html,body").animate(
	  {
		scrollTop: $(thisId).offset().top - scrollOffset
	  },
	  800
	);

	return false;
  });
};

//localize popup toggle
theme.localizeToggle = function() {
  var box = $(".js-localize-box");
  var trigger = $(".js-localize-trigger");
  var item = $(".js-localize-item");
  var activeClass = "js-active";

  item.click(function() {
  	var value = $(this).data('value');

    $(this).parents('.js-localize-wrapper').find("[data-disclosure-input]").val(value);
    $(this).parents('form').submit();

    return false;
  });

  trigger.click(function() {

	var thisTarget = $(this).parents('.js-localize-wrapper').find(box);

	if ($(this).hasClass(activeClass)) {
	  $(this).removeClass(activeClass).attr("aria-expanded", "false");
	  $(thisTarget).removeClass(activeClass);
	} else {
	  box.removeClass(activeClass);
      trigger.removeClass(activeClass).attr("aria-expanded", "false");

	  $(thisTarget).addClass(activeClass);
	  $(this).addClass(activeClass).attr("aria-expanded", "true");
	}

	return false;
  });

  //basic accessibility for keyboard
  box
	.focusin(function() {
	  $(this).addClass(activeClass);
	  $(this).parents('.js-localize-wrapper').find(trigger).addClass(activeClass).attr("aria-expanded", "true");
	})
	.focusout(function() {
	  $(this).removeClass(activeClass);
	  $(this).parents('.js-localize-wrapper').find(trigger).removeClass(activeClass).attr("aria-expanded", "false");
	});

  //click outside elem to hide functions
  $(document).click(function(e) {
	if (!box.is(e.target) && box.has(e.target).length === 0) {
	  box.removeClass(activeClass);
	  trigger.removeClass(activeClass).attr("aria-expanded", "false");
	}
  });
};

//header nav functions
theme.headerNav = function() {
  var link = $(".js-header-sub-link");
  var tLink = $(".js-header-sub-t-link");
  var linkA = $(".js-header-sub-link-a");
  var tLinkA = $(".js-header-sub-t-a");
  var activeClass = "js-active";

  var headerNavs = $(".js-header-navs");
  var mobileDraw = $(".js-mobile-draw-icon");
  var searchDraw = $(".js-search-draw-icon");
  var cartDraw = $(".js-cart-draw-icon");
  var primaryNav = $(".js-primary-nav");
  var secondaryNav = $(".js-secondary-nav");
  var logoImg = $(".js-main-logo");

  //nav accessibility for keyboard
  link
	.focusin(function() {
	  $(this).addClass(activeClass);
	  $(this).find(linkA).attr("aria-expanded", "true");
	})
	.focusout(function() {
	  link.removeClass(activeClass);
	  $(this).find(linkA).attr("aria-expanded", "false");
	});
  tLink.focusin(function() {
	tLink.removeClass(activeClass);
	tLinkA.attr("aria-expanded", "false");
	$(this).addClass(activeClass);
	$(this).find(tLinkA).attr("aria-expanded", "true");
  });
  link.mouseout(function() {
	$(this).removeClass(activeClass);
  });
  tLink.mouseout(function() {
	$(this).removeClass(activeClass);
  });

  //disable parent links
  $(".header--parent-disabled .js-header-sub-link-a, .header--parent-disabled .js-header-sub-t-a").click(function(e) {
	e.preventDefault();
  });

  //responsive events
  $(window)
	.resize(function() {
	  //get sizes
	  winWidth = $(window).width();
	  var navsWidth = headerNavs.width();
	  var primaryWidth = primaryNav.width();
	  var secondaryWidth = secondaryNav.width();
	  var logoWidth = logoImg.width();
	  //calculate available space for primary nav
	  var navSpace = navsWidth / 2 - logoImg.width() / 2;
	  if (winWidth >= theme.mobileBrkp) {
			if (!$(".js-header").hasClass("header--center")) {
				if (navSpace < primaryWidth) {
					$(".js-header").removeClass('header--inline-icons');
					mobileDraw.show();
					searchDraw.show();
					cartDraw.show();
					primaryNav.hide();
					secondaryNav.hide();
				} else {
					mobileDraw.hide();
					searchDraw.hide();
					cartDraw.hide();
					primaryNav.show();
					secondaryNav.show();
				}
			} else {
				$(".js-header").removeClass('header--inline-icons');
				mobileDraw.hide();
				searchDraw.hide();
				cartDraw.hide();
			}
	  } else {
			mobileDraw.show();
			searchDraw.show();
			cartDraw.show();
	  }
	})
	.resize();

  //caculate if third sub nav should appear on right ON MOUSEOVER
  tLink.on("mouseover focusin", function() {
	var subNavT = $(this).find(".js-nav-sub-t");
	//calc sub nav offset compared to window width
	var ofsNo = winWidth - (subNavT.offset().left + subNavT.width());
	//place subnav
	if (ofsNo < 1) {
	  subNavT.css("right", "179px");
	  subNavT.css("left", "auto");
	}
  });
};

//home single product carousel
theme.homeFeaturedProduct = function() {
	$(".js-section__home-product .js-product-slider").not(".slick-initialized").each( function() {
      $(this).slick({
        slidesToShow: 1,
  			slidesToScroll: 1,
  			accessibility: true,
  			arrows: true,
  			dots: true,
  			fade: true,
  			adaptiveHeight: true,
  			infinite: false,
  			swipe: true,
  			speed: 300,
  			cssEase: "ease",
  			prevArrow: '<div class="product-featured__photo__nav__item product-featured__photo__nav__item--prev"><i class="icon icon--left"></i></div>',
  			nextArrow: '<div class="product-featured__photo__nav__item product-featured__photo__nav__item--next"><i class="icon icon--right"></i></div>',
  			appendDots: $(this).parent().find('.js-product-slider-nav-dots'),
  			appendArrows: $(this).parent().find('.js-product-slider-nav')
      });
  });
};

//toggle active class on traget div
theme.triggerActive = function() {
  var $target = $(".js-toggle-target");
  var trigger = $(".js-toggle-trigger");
  var activeClass = "js-active";

  trigger.click(function(e) {
  	var thisTarget = $(this).data('ref')
    if (!thisTarget) {
      thisTarget = $(this).attr("href");
    }

  	if ($(this).hasClass(activeClass)) {
  	  $(this).removeClass(activeClass);
  	  $(thisTarget).removeClass(activeClass);
  	  //accessibility
  	  $(this)
  		.parent()
  		.attr("aria-expanded", "false");
  	} else {
  	  $(this).addClass(activeClass);
  	  $(thisTarget).addClass(activeClass);
  	  //accessibility
  	  $(this)
  		.parent()
  		.attr("aria-expanded", "true");
  	}
  	e.preventDefault();
    });
};

//select dropdown styling
theme.selectWrapper = function() {
  //add to each select so label can sit next to it
  //no js-... classes this time
  function setWidth() {
	$(".selector-wrapper").each(function(i) {
	  var labelWidth = $(this)
		.find("label")
		.width();
	  $(this)
		.find("select")
		.css("padding-left", 20 + labelWidth);
	});
  }
  setWidth();
  setTimeout(setWidth, 500);//repeat
  setTimeout(setWidth, 2000);//repeat
};

theme.selectWrapper();


//check if two sections in row have backgrounds and if so collapse margin
theme.homeSectionMargin = function() {
  $(".shopify-section").each(function() {
	var thisSection = $(this).find(".section");

	//remove style attr for theme editor to display correctly without refresh
	thisSection.removeAttr("style");
	if (
	  thisSection.hasClass("section--has-bg") &&
	  $(this)
		.next()
		.find(".section")
		.is(".section--full-bg.section--has-bg")
	) {
	  thisSection.css("margin-bottom", "0");
	}
  });
};

//age checker popup
theme.ageCheckerCookie = function() {
  var ageCookie = "age-checked";

  if ($(".js-age-draw").data("age-check-enabled")) {
	if (typeof Cookies != "undefined") {
	  if (Cookies(ageCookie) !== "1") {
		theme.mfpOpen("age");
	  }
	}
  }

  $(".js-age-close").click(function(e) {
	Cookies(ageCookie, "1", { expires: 14, path: "/" });
	$.magnificPopup.close();

	e.preventDefault();
  });
};
//promo popup
theme.promoPopCookie = function() {
  var promoCookie = "promo-showed";
  var promoDelay = $(".js-promo-pop").data("promo-delay");
  var promoExpiry = $(".js-promo-pop").data("promo-expiry");

  if ($(".js-promo-pop").data("promo-enabled")) {
	if (typeof Cookies != "undefined") {
	  if (Cookies(promoCookie) !== "1") {
		setTimeout(function() {
		  theme.promoPop("open");
		}, promoDelay);
	  }
	}
  }

  $(".js-promo-pop-close").click(function(e) {
	Cookies(promoCookie, "1", { expires: promoExpiry, path: "/" });
	theme.promoPop("close");

	e.preventDefault();
  });
};

theme.footerTweet = function() {
  //set vars
  var twtEnable = $(".js-footer-tweet").data("footer-tweet-enable");

  if (twtEnable) {
	var twtUsername = $(".js-footer-tweet")
	  .data("footer-tweet-user")
	  .substring(1);

	//load twitter widgets JS
	window.twttr = (function(d, s, id) {
	  var js,
		fjs = d.getElementsByTagName(s)[0],
		t = window.twttr || {};
	  if (d.getElementById(id)) return t;
	  js = d.createElement(s);
	  js.id = id;
	  js.src = "https://platform.twitter.com/widgets.js";
	  fjs.parentNode.insertBefore(js, fjs);

	  t._e = [];
	  t.ready = function(f) {
		t._e.push(f);
	  };

	  return t;
	})(document, "script", "twitter-wjs");

	//load feed
	twttr.ready(function() {
	  twttr.widgets
		.createTimeline(
		  {
			sourceType: "profile",
			screenName: twtUsername
		  },
		  document.getElementById("footer-tweet"),
		  {
			tweetLimit: 1
		  }
		)
		.then(function(data) {
		  //get tweet and ass
		  var tweetText = $(data)
			.contents()
			.find(".timeline-Tweet-text")
			.html();
		  $(".js-footer-tweet-text").html(tweetText);
		});
	});
  }
};

//magnific popup functions
theme.mfpOpen = function(popup) {
  var closeBtn =
	'<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp"><i class="icon icon--close"></i></button>';

  switch (popup) {
	case "slide-cart":
		if (theme.cart_ajax) {
			ajaxCart.open()
		}
		break;


	case "cart":
	  if (theme.cart_ajax) {
		$.magnificPopup.open({
		  items: {
			src: ".js-cart-draw"
		  },
		  type: "inline",
		  mainClass: "mfp-medium",
		  fixedContentPos: true,
		  midClick: true,
		  closeMarkup: closeBtn,
		  removalDelay: 200
		});
	  }
	  break;

	case "search":
	  $.magnificPopup.open({
		items: {
		  src: ".js-search-draw"
		},
		type: "inline",
		mainClass: "mfp-medium",
		fixedContentPos: true,
		focus: ".js-search-input",
		closeMarkup: closeBtn,
		removalDelay: 200
	  });
	  break;

	case "age":
	  $.magnificPopup.open({
		items: {
		  src: ".js-age-draw"
		},
		type: "inline",
		mainClass: "mfp-dark",
		fixedContentPos: true,
		modal: true,
		showCloseBtn: false,
		removalDelay: 200
	  });
	  break;

	case "menu-draw":
	  $.magnificPopup.open({
		items: {
		  src: ".js-menu-draw"
		},
		type: "inline",
		mainClass: "mfp-draw",
		fixedContentPos: true,
		closeMarkup: closeBtn,
		removalDelay: 200
	  });
	  break;

	case "collection-draw":
	  $.magnificPopup.open({
		items: {
		  src: ".js-collection-draw"
		},
		callbacks: {
		  resize: function() {
			if ($('.js-collection-draw').hasClass('collection-sidebar--sidebar') && winWidth >= theme.tabletBrkp) {
			  $.magnificPopup.close();
			}
		  }
		},
		type: "inline",
		mainClass: "mfp-draw",
		fixedContentPos: true,
		closeMarkup: closeBtn,
		removalDelay: 200
	  });
	  break;
  }
};

theme.collectionSort = function() {
  Shopify.queryParams = {};
  if (location.search.length) {
	for (
	  var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
	  i < aCouples.length;
	  i++
	) {
	  aKeyValue = aCouples[i].split("=");
	  if (aKeyValue.length > 1) {
		Shopify.queryParams[
		  decodeURIComponent(aKeyValue[0])
		] = decodeURIComponent(aKeyValue[1]);
	  }
	}
  }

  var defaultSort = $(".js-collection-sort").data("default-sort");
  $("#SortBy")
	.val(defaultSort)
	.bind("change", function() {
	  Shopify.queryParams.sort_by = jQuery(this).val();
	  location.search = jQuery.param(Shopify.queryParams);
	});
};

theme.magnificVideo = function() {
  $(".js-pop-video").magnificPopup({
	type: "iframe",
	mainClass: "mfp-medium mfp-close-corner",
	removalDelay: 200,
	closeMarkup:
	  '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom js-close-mfp"><i class="icon icon--close"></i></button>'
  });
};

theme.productZoom = function() {
	var openPhotoSwipe = function(thisBtn, thisImageCount) {
	    var pswpElement = document.querySelectorAll('.pswp')[0];
	    var productGallery = $('.js-product-slider');

	    // build gallery array
	    var galleryItems = [];
	    $('.js-pswp-img').each(function() {
	      var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
	      var item = {
	      	msrc: smallSrc,
	        src: $(this).data('pswp-src'),
	        w: $(this).data('pswp-width'),
	        h: $(this).data('pswp-height'),
	        mediaId: $(this).data('media-id'),
	        el: $(this)[0]
	      };
	      galleryItems.push(item);
	    });

	    var options = {
	        history: false,
	        index: thisImageCount,
	        closeOnScroll: false,
	        getThumbBoundsFn: function() {
	            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
	            var thumbnail = galleryItems[thisImageCount].el;
	            var rect = thumbnail.getBoundingClientRect();
	            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
	        }
	    };

	    var pswpGallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, galleryItems, options);
	    pswpGallery.init();
	    pswpGallery.listen('close', function() {
	    	var thisSlideItem = $('.product-single__photo__item[data-media-id=' + this.currItem.mediaId + ']');
	    	productGallery.slick('slickGoTo', thisSlideItem[0].dataset.slideId);
	    });
	};

	$(document).on('click', '.js-pswp-zoom', function() {
		var thisBtn = $(this);
		var thisImageCount = $(this).data('image-count');
		openPhotoSwipe(thisBtn, thisImageCount);
	});

};

theme.promoPop = function(action) {
  var popup = $(".js-promo-pop");
  var activeClass = "js-active";

  if (action == "open") {
	popup.addClass(activeClass);
  } else if (action == "close") {
	popup.removeClass(activeClass);
  }
};

const bundleDiscountCodes = {
  "The Mosaic Two Case Bundle": "MOSAIC TWO CASE",
  "The Citra Two Case Bundle": "CITRA TWO CASE",
  "The Citra Two Case Bundle (Caffeine Free)": "CITRA TWO CASE CAFF-FREE",
  "Sabro/White Tea Two Case Bundle": "SABRO WHITE TWO CASE",
  "Mixed Water/Relax Bundle": "WATER RELAX TWO CASE"
}

theme.processBundlerCart = function(proceedToCheckout){
  // Process Bundler Cart

  ShopifyAPI.getCart(function(cart){
    // save original ~bundled cart to sessionStorage.
    // add bundler items to cart
    // remove bundle
    // continue to checkout
    sessionStorage.setItem('originalCart', JSON.stringify(cart));

    var itemsToAdd = []
    var updates = {}
    let discountCode;

    cart.items.forEach(item => {
      var propertyKeys = Object.keys(item.properties);
      var bundleNumber = parseInt((Math.random() * 100000));

      var itemIsBundle = false;

      propertyKeys.forEach(key => {
        if (key[0] === "_" && key !== "_igTestGroup" && key !== "_igp") {
          var variantId = key.replace("_", "");
          var newItem = {
            id: parseInt(variantId),
            quantity: parseInt(item.properties[key]) * item.quantity,
            properties: {
              "Bundle #": bundleNumber
            }
          }

          itemsToAdd.push(newItem);
          itemIsBundle = true;
        }
      })

      if (itemIsBundle){
        discountCode = bundleDiscountCodes[item.title]
        updates[item.variant_id] = 0
      }
    });

    jQuery.post('/cart/update.js', {
      updates: updates
    }).then(function(){
      jQuery.post('/cart/add.js', {
        items: itemsToAdd
      }).then(function(){
        proceedToCheckout(discountCode)
      });
    })
  });
}

theme.cartCheckbox = function() {
  function proceedToCheckout(discountCode) {

    if ($('.js-recharge-item').length){
      var url = window.reChargeProcessCart(e);
      location.href = url;
    } else {
      let href = '/checkout';
      if (discountCode) {
        href += ("?discount=" + discountCode);
        location.href = href;
      } else {
        location.href = href;
      }
    }
  }

  function handleCheckoutSubmit(e){
    var $target = $(e.target);

    e.preventDefault()

    let bundleDiscount;

    function proceedToCheckout(discountCode) {


      if ($('.js-recharge-item').length){
        var url = window.reChargeProcessCart(e);
        location.href = url;
      } else {
        let href = '/checkout';
        if (discountCode) {
          href += ("?discount=" + discountCode);
          location.href = href;
        } else {
          location.href = href;
        }
      }
    }

		// TS: pixel-helper.js.liquid | pixelAdapter.initiateCheckout()
		$.getJSON('/cart.js', function (cart) {
			pixelAdapter.initiateCheckout(cart);
		});

    if ($target.hasClass('js-bundle-products')){
      theme.processBundlerCart(proceedToCheckout);
    } else if ($('.js-recharge-item').length){
      var url = window.reChargeProcessCart(e);
      location.href = url;
    } else {
      location.href = '/checkout';
    }
  }

	$(document).on('click', '.js-process-checkout, .ajaxcart__checkout, .cart__checkout', handleCheckoutSubmit);

  // make sure first recharge frequency option is checked by default
  $('input.rc_radio').on('change', function(){
    if( $('input[value="autodeliver"]').is( ":checked" )){
      $('input.js-ship-frequency[data-order=1]').click()
    } else {
      $('input.js-ship-frequency').each( function (){
        $(this).prop('checked', false);
      })
    }
  })

};

theme.megaMenu = function(){

  var settings = {
    megaMenu: ".js-mega-menu",
    menuLinks: ".js-menu-link",
    megaLinks: ".js-mega-link",
    megaClose: ".js-mega-close"
  }

  var init = function(){
    if (!$(settings.megaMenu).length) return

    initilizeMenuLinks();
    initializeEventListeners();
  }

  var initilizeMenuLinks = function(){
    $(settings.menuLinks).each(function(index, el){
      var dataLink = $(el).data('link');
      var $megaMenu = $(settings.megaMenu + '[data-link="' + dataLink + '"]');

      if ($megaMenu.length) {
        $(el).addClass('js-mega-link');
      }
    })
  }

  var initializeEventListeners = function(){
    if (window.screen.availWidth > 768) {
      $(document).on('mouseover', settings.menuLinks, openMegaMenu);
      $(document).on('mouseover', ".main", closeMegaMenu);
    } else {
      $(document).on('click', settings.megaLinks, openMegaMenu);
      $(document).on('click', settings.megaClose, toggleMegaMenu);
    }

    $(window).on('scroll', handleMenuPosition);
  }

  var openMegaMenu = function(e){
    e.preventDefault();
    var $this = $(this);
    var dataLink = $this.data('link');

    var $megaMenu = $(settings.megaMenu + '[data-link="' + dataLink + '"]');

    var hasActiveMenu = !!$(settings.megaMenu + ".active").length;

    if (hasActiveMenu) {
      $megaMenu.addClass('active');
    } else {
      $megaMenu.addClass('animate');
      $megaMenu.addClass('active');
    }
    $this.find('a').addClass('active');


    $(settings.megaMenu).not($megaMenu).removeClass('active animate');
    $(settings.menuLinks).not($this).find('a').removeClass('active');

    $(document).on('click', ".mfp-content", closeMegaMenu);
  }

  var closeMegaMenu = function(e){
    var $menu = $(settings.megaMenu);
    var $link = $(settings.menuLinks);

    $link.find('a').removeClass('active');
    $menu.removeClass('active');

    $(document).off('click', ".mfp-content", closeMegaMenu);
  }

  var toggleMegaMenu = function(e){
    e.preventDefault();

    var $menu = $(settings.megaMenu);
    var $link = $(settings.menuLinks);

    $link.find('a').removeClass('active');
    $menu.removeClass('active');

    $(document).off('click', ".mfp-content", closeMegaMenu);
  }

  var handleMenuPosition = function(e){
    if (window.scrollY < 45) {
      var topPosition = 104 - window.scrollY;
    } else {
      var topPosition = 59;
    }

    $(settings.megaMenu).css({ top: topPosition });
  }

  // initialize mega menu module
  init();
}

//product page recommendations
theme.productRecommendations = function() {
  // Look for an element with class 'js-product-recommendations'
  var productRecommendationsSection = document.querySelector('.js-product-recommendations');
  if (productRecommendationsSection === null) {return;}
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.baseUrl + '?section_id=product-recommendations&limit='+limit+'&product_id='+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open('GET', requestUrl);
  request.onload = function() {
	if (request.status >= 200 && request.status < 300) {
	  var container = document.createElement('div');
	  container.innerHTML = request.response;
	  productRecommendationsSection.parentElement.innerHTML = container.querySelector('.js-product-recommendations').innerHTML;

	  //run ajax cart functions
	  // theme.runAjaxCart();

	  //product swatches
	  theme.productCollSwatch();

	  //mobile carousel
	  $(".js-related-products").each(function(i) {
  		var thisSectionId = $(this).data("section-id");
  		theme.layoutSlider(".js-layout-slider-" + thisSectionId);
	  });

	  //reset scrolling animations
	  //delaying so the animation doesn't interfere with the main SR function
	  if ($("body").data("anim-load")) {
		setTimeout(function(){
		  sr.reveal('.section--related-products .product-top', { interval: theme.intervalValue });
		  sr.reveal('.section--related-products .section__title', { distance: "5px" });
		}, 1000);
	  }
	}
  };
  request.send();
};

var homepage = (function(){
  var settings = {
    canContainer: ".js-can-container",
    canImage: ".js-can-image"
  }

  var init = function(){
    if (!$(settings.canContainer).length) return

    $(settings.canImage).on('mouseover', addHoverClass);
    $(settings.canImage).on('mouseout', removeHoverClass);
  }

  var addHoverClass = function(){
    $(settings.canContainer).addClass('active');
  }

  var removeHoverClass = function(){
    $(settings.canContainer).removeClass('active');
  }


  return {
    init: init
  }

})()

$(document).ready(function() {
  //Open AJAX cart after new item is added
  if (location.pathname !== '/cart') {
    $("body").on("afterAddItem.ajaxCart", function() {
    	setTimeout(function() {
    	  theme.mfpOpen("slide-cart");
    	}, 100);
    });
  }

  //wait for TAB to be clicked and add class for outline accessible class
  function tabClick(e) {
    if (e.keyCode === 9) {
      body.addClass('js-using-tab');
      window.removeEventListener('keydown', tabClick);
    }
  }
  window.addEventListener('keydown', tabClick);

  //home events get feed
  $(".js-events").each(function(i) {
	var thisSectionId = $(this).data("section-id");
	var thisApiKey = $(this).data("api-key");
	theme.eventFeed(
	  thisApiKey,
	  "#eventTemplate" + thisSectionId,
	  "#eventContainer" + thisSectionId,
	  thisSectionId
	);
  });
  //mobile sliders
  $(".js-events-onboarding").each(function(i) {
	var thisSectionId = $(this).data("section-id");
	theme.layoutSlider(".js-layout-slider-" + thisSectionId);
  });
  $(".js-home-collection-list").each(function(i) {
	var thisSectionId = $(this).data("section-id");
	theme.layoutSlider(".js-layout-slider-" + thisSectionId);
  });
  $(".js-home-products").each(function(i) {
	var thisSectionId = $(this).data("section-id");
	theme.layoutSlider(".js-layout-slider-" + thisSectionId);
  });
	$(".js-featured-products-slider").each(function(i) {
		var thisSectionId = $(this).data("section-id");
		theme.layoutSlider(".js-layout-slider-" + thisSectionId);
  });
  $(".js-page-products").each(function(i) {
	var thisSectionId = $(this).data("section-id");
	theme.layoutSlider(".js-layout-slider-" + thisSectionId);
  });
  $(".js-home-testimonials").each(function(i) {
  	var thisSectionId = $(this).data("section-id");
    $(this).not(".slick-initialized").slick({
      slidesToShow: 1,
      infinite: false,
      dots: false,
      arrows: false,
      centerMode: true,
      fade: true,
      centerPadding: "30px"
    });
  });

  // hoptea icon slider
  // mobile /tablet only!

  $('.js-icon-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 2000,
    autoplay: true,
    mobileFirst: true,
    centerPadding: "90px",
    responsive: [
      {
        breakpoint: 1200,
        settings: "unslick"
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  })


  //fitvids
  $(".video-wrapper").fitVids();
  //rich text fitvids
  $('.rte iframe[src*="youtube"]')
	.parent()
	.fitVids();
  $('.rte iframe[src*="vimeo"]')
	.parent()
	.fitVids();

  //rich text table overflow
  $(".rte table").wrap(
	"<div style='overflow:auto;-webkit-overflow-scrolling:touch'></div>"
  );

  //move maps inside tab on mobile
  $(".js-map-replace").appendAround();
  //move cart box for classic layout
  $(".js-cart-replace").appendAround();

  //search popup trigger click
  $(document).on("click", ".js-search-trigger", function(e) {
	theme.mfpOpen("search");
	e.preventDefault();
  });
  //cart popup trigger click
	$(document).on("click", ".js-cart-trigger", function(e) {
    if (location.pathname !== "/cart") {
      theme.mfpOpen("slide-cart");
  	  e.preventDefault();
    }
	});

  //mobile menu drawer trigger click
  $(document).on("click", ".js-mobile-draw-trigger", function(e) {
	theme.mfpOpen("menu-draw");
	e.preventDefault();
  });

  //collection sidebar drawer trigger click
  $(document).on("click", ".js-collection-draw-trigger", function(e) {
	theme.mfpOpen("collection-draw");
	e.preventDefault();
  });

  //magnific js close link
  $(document).on("click", ".js-close-mfp", function(e) {
	$.magnificPopup.close();
	e.preventDefault();
  });

  //fixing lazyload image masonry layout
  $(document).on("lazybeforeunveil", function() {
	theme.masonryLayout();
  });

  //recalculating imagelazy sizes after few seconds and after scroll reveal for product
  function checkLazySize(){
    lazySizes.autoSizer.checkElems();
  }
  setTimeout(checkLazySize(), 2000);
  // setTimeout(checkLazySize(), 4000);

  //general
  //check if recommended products are not present and init cart
  //checking to avoid double cart initiation
  // if (document.querySelector('.js-product-recommendations') === null) {
  // 	theme.runAjaxCart();
  // }

  homepage.init();

  theme.productRecommendations();
  theme.masonryLayout();
  theme.selectWrapper();
  theme.triggerActive();
  theme.headerNav();
  theme.megaMenu();
  theme.localizeToggle();
  theme.magnificVideo();
  theme.ageCheckerCookie();
  theme.promoPopCookie();
  theme.footerTweet();
  theme.scrollToDiv();
  theme.animFade();
  theme.animScroll();
  theme.productCollSwatch();
  theme.cartCheckbox();

  //homepage
  theme.homeMaps();
  theme.homeVideoGallery();
  theme.homeMainCarousel();
  theme.homeProductMediaInit();
  theme.homeFeaturedProduct();
  theme.homeSectionMargin();
  theme.testimonialsCarousel();
  theme.logoCarousel();

  //collection
  theme.collectionSort();

  //product single
  theme.productMediaInit();
  theme.thumbsCarousel();
  theme.scrollToFixedFaq();
  theme.scrollToFixedHeader();
  theme.headerScrollUp();
  theme.accordion();
  theme.productZoom();

  if (location.search.includes("discount=2021")) {
    sessionStorage.setItem('discount', true);
  }
});

// Shopify functions
//
//

// Theme Editor
$(document)
  .on("shopify:section:load", function(event) {
	var section = $(event.target);
	var type = section
	  .attr("class")
	  .replace("shopify-section", "")
	  .trim();
	var id = event.originalEvent.detail.sectionId;
	var sectionId = ".section--" + id;

	theme.homeSectionMargin();
	if ($("body").data("anim-load")) {
	  sr.reveal(sectionId + " .section__title", { distance: "5px" });
	  sr.reveal(sectionId + " .section__title-desc", {
		distance: 0,
		delay: 300
	  });
	  sr.reveal(sectionId + " .section__link", { distance: 0 });
	}

	switch (type) {
	  case "js-section__home-collection":
		theme.layoutSlider(".js-layout-slider-" + id);
		theme.masonryLayout();
		theme.productCollSwatch();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .product-top", {
			interval: theme.intervalValue
		  });
		}
		break;

		case "js-section__featured-collection":
			theme.layoutSlider(".js-layout-slider-" + id);
			theme.masonryLayout();
			theme.productCollSwatch();
			if ($("body").data("anim-load")) {
				sr.reveal(sectionId + " .product-top", {
				interval: theme.intervalValue
				});
			}
		break;

	  case "js-section__home-events":
		var thisEvents = $(".js-events-" + id);
		var thisSectionId = thisEvents.data("section-id");
		var thisApiKey = thisEvents.data("api-key");
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-event__item", {
			interval: theme.intervalValue
		  });
		}
		//check if onboarding content exists
		if ($(section).find(".js-events-onboarding").length) {
		  theme.layoutSlider(".js-layout-slider-" + id);
		} else {
		  theme.eventFeed(
			thisApiKey,
			"#eventTemplate" + thisSectionId,
			"#eventContainer" + thisSectionId,
			thisSectionId
		  );
		}
		break;

	  case "js-section__home-slider":
		//reset each youtube video object (weird YT re-init bug)
		section.find(".js-home-carousel-video-data").each(function() {
		  var playerId = $(this).attr("data-player-id");
		  window[playerId] = "undefined";
		});
		theme.homeMainCarousel();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-carousel", { distance: 0 });
		}
		break;

	  case "js-section__home-testimonials":
		theme.testimonialsCarousel();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-testimonials", { distance: 0 });
		}
		break;

	  case "js-section__home-image-grid":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-image-grid__item", {
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__home-logo-list":
		theme.logoCarousel();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-logo-list__items", { distance: 0 });
		}
		break;

	  case "js-section__home-video":
		theme.homeVideoGallery();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-video__stage, .home-video__items", {
			distance: 0
		  });
		}
		break;

	  case "js-section__home-blog":
		theme.masonryLayout();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .blog", {
			delay: 500,
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__home-intro":
		theme.magnificVideo();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-intro", { distance: 0 });
		  sr.reveal(
			sectionId +
			  " .home-intro__media," +
			  sectionId +
			  " .home-intro__text," +
			  sectionId +
			  " .home-intro__video," +
			  sectionId +
			  " .home-intro__link-wrap"
		  );
		}
		break;

	  case "js-section__home-promo":
		theme.magnificVideo();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-promo__box");
		}
		break;

	  case "js-section__home-custom":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-custom__item", {
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__home-html":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-html", { distance: 0 });
		}
		break;

	  case "js-section__rich-text":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-rich-text__content", { distance: 0 });
		}
		break;

	  case "js-section__home-map":
		$(".js-map-replace").appendAround();
		theme.homeMaps();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-map__items");
		}
		break;

	  case "js-section__home-delivery":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-delivery", { distance: 0 });
		  sr.reveal(sectionId + " .home-delivery__content", {
			distance: theme.intervalStyle
		  });
		}
		break;

	  case "js-section__home-inline":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-inline__item", {
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__home-collection-list":
		theme.layoutSlider(".js-layout-slider-" + id);
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .collection-list__item", {
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__home-product":
		//check if onboarding
		if (
		  $(this)
			.find(".section")
			.attr("data-section-onboarding") != "true"
		) {
		  theme.productSelect(id, "featured", false);
		}
		theme.selectWrapper();
		// theme.runAjaxCart();
		theme.homeProductMediaInit();

		//slider images smooth loading
		$(".js-product-slider").hide();
		$(".js-product-slider-spinner").show();
		$(".js-product-slider").imagesLoaded(function() {
		  $(".js-product-slider").show();
		  $(".js-product-slider-spinner").hide();
		  theme.homeFeaturedProduct();
		});
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .product-featured__details", { distance: 0 });
		  sr.reveal(sectionId + " .product-featured__photo-wrapper", {
			distance: 0,
			delay: 500
		  });
		}
		break;

	  case "js-section__product-single":
		theme.selectWrapper();
		theme.accordion();
		// theme.runAjaxCart();

		theme.productSelect("1", "single", true);
		theme.selectWrapper();
		theme.productMediaInit();

		//slider images smooth loading
		$(".js-product-slider").imagesLoaded(function() {
		  theme.thumbsCarousel();
		});

		//move cart box for classic layout
		$(".js-cart-replace").appendAround();

		if ($("body").data("anim-load")) {
		  sr.reveal(".product-single__title-text", { distance: "20px" });
		  sr.reveal(".product-single__title-desc, .breadcrumb, .product-single__photos, .product-single__content, .product-single--minimal .product-single__content-text", { distance: 0, delay: 500 });
		}
		break;

	  case "js-section__product-testimonials":
		theme.testimonialsCarousel();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-testimonials", { distance: 0 });
		}
		break;

	  case "js-section__product-custom":
		if ($("body").data("anim-load")) {
		  sr.reveal(".home-custom__item", { interval: theme.intervalValue });
		  sr.reveal(".home-image-grid__item", {
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__product-related":
		theme.productRecommendations();
		break;

	  case "js-section__blog":
		theme.masonryLayout();
		theme.layoutSlider(".js-layout-slider-" + id);
		theme.productCollSwatch();

		if ($("body").data("anim-load")) {
		  sr.reveal(".blog", { delay: 500, interval: theme.intervalValue });
		  sr.reveal(".blog-page__tags, .blog-pagination", {
			distance: 0,
			delay: 500
		  });
		  sr.reveal(".blog-page .section__title", { distance: "20px" });
		  sr.reveal(".product-top", { interval: theme.intervalValue });
		}
		break;

	  case "js-section__article":
		theme.masonryLayout();
		theme.layoutSlider(".js-layout-slider-" + id);
		theme.productCollSwatch();

		if ($("body").data("anim-load")) {
		  sr.reveal(".article .section__title", { distance: "20px" });
		  sr.reveal(".article__date", { distance: "-10px", delay: 500 });
		  sr.reveal(".article__featured-media, .article__content", {
			distance: 0,
			delay: 200
		  });
		  sr.reveal(".article__meta, .article-paginate", { distance: 0 });
		  sr.reveal(".product-top", { interval: theme.intervalValue });
		}
		break;

	  case "js-section__header":
		theme.scrollToFixedHeader();
		theme.headerNav();
		theme.triggerActive();
		theme.localizeToggle();
		theme.headerScrollUp();

		break;

	  case "js-section__newsletter":
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .newsletter", { distance: 0 });
		}
		break;

	  case "js-section__footer":
		theme.footerTweet();
		theme.localizeToggle();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .newsletter", { distance: 0 });
		}
		break;

	  case "js-section__collection":
		theme.selectWrapper();
		theme.masonryLayout();
		theme.collectionSort();
		theme.productCollSwatch();

		if ($("body").data("anim-load")) {
		  sr.reveal(".collection__header-info__title", { distance: "20px" });
		  sr.reveal(".collection .product-top", {
			interval: theme.intervalValue,
			delay: 500
		  });
		  sr.reveal(
			".collection__header-media, .collection__header-info__text, .collection-main__sort, .collection-empty, .collection-pagination",
			{ distance: 0, delay: 500 }
		  );
		}
		break;

	  case "js-section__list-collections":
		if ($("body").data("anim-load")) {
		  sr.reveal(".list-collections .section__title", { distance: "20px" });
		  sr.reveal(".list-collections .collection-list__item", {
			interval: theme.intervalValue,
			delay: 500
		  });
		}
		break;

	  case "js-section__mobile-draw":
		theme.triggerActive();
		theme.localizeToggle();
		break;

	  case "js-section__promo-pop":
		if ($("body").data("anim-load")) {
		  sr.reveal(".promo-pop .section__title", { distance: 0 });
		}
		break;

	  case "js-section__faq-page":
		theme.accordion();
		theme.scrollToFixedFaq();
		theme.scrollToDiv();
		if ($("body").data("anim-load")) {
		  sr.reveal(".page .section__title", { distance: "20px" });
		  sr.reveal(".faq__cta", { distance: 0, delay: 500 });
		  sr.reveal(".faq__search", { distance: 0, delay: 700 });
		  sr.reveal(".faq__accordion", { distance: 0, delay: 900 });
		  sr.reveal(".page__contact-form", { distance: 0, delay: 200 });
		  sr.reveal(".faq__category__title", { distance: 0 });
		}
		break;

	  case "js-section__page-custom":
		if ($("body").data("anim-load")) {
		  sr.reveal(".home-custom__item", { interval: theme.intervalValue });
		  sr.reveal(".home-image-grid__item", {
			interval: theme.intervalValue
		  });
		}
		break;

	  case "js-section__page-contact":
		$(".js-map-replace").appendAround();
		theme.homeMaps();
		if ($("body").data("anim-load")) {
		  sr.reveal(sectionId + " .home-map__items");
		  sr.reveal(".page__contact-form", { distance: 0, delay: 200 });
		}
		break;
	}
  })
  .on("shopify:section:reorder", function(event) {
	theme.homeSectionMargin();
  })
  .on("shopify:section:select", function(event) {
	var section = $(event.target);
	var type = section
	  .attr("class")
	  .replace("shopify-section", "")
	  .trim();
	var id = event.originalEvent.detail.sectionId;

	switch (type) {
	  case "js-section__mobile-draw":
		//record current top offset
		theme.currentOffset = $(document).scrollTop();
		theme.mfpOpen("menu-draw");
		break;

	  case "js-section__age-checker":
		var ageEnabled = $(section)
		  .find(".js-age-draw")
		  .data("age-check-enabled");
		if (ageEnabled) {
		  theme.mfpOpen("age");
		} else {
		  $.magnificPopup.close();
		}
		//record current top offset
		theme.currentOffset = $(document).scrollTop();
		break;

	  case "js-section__promo-pop":
		var promoEnabled = $(section)
		  .find(".js-promo-pop")
		  .data("promo-enabled");
		if (promoEnabled) {
		  theme.promoPop("open");
		} else {
		  theme.promoPop("close");
		}
		//record current top offset
		theme.currentOffset = $(document).scrollTop();
		break;

	  case "js-section__home-slider":
		var currSlideshowSection = $('[data-section-id="' + id + '"]').find(
		  ".js-home-carousel"
		);
		//pause carousel autoplay
		currSlideshowSection.slick("slickPause");
		break;

	  case "js-section__home-testimonials":
		var currTestimonialsSection = $('[data-section-id="' + id + '"]').find(
		  ".js-home-testimonials-carousel"
		);
		//pause carousel autoplay
		currTestimonialsSection.slick("slickPause");
		break;

	  case "js-section__product-testimonials":
		var currProdTestimonialsSection = $(
		  '[data-section-id="' + id + '"]'
		).find(".js-home-testimonials-carousel");
		//pause carousel autoplay
		currProdTestimonialsSection.slick("slickPause");
		break;
	}
  })
  .on("shopify:section:deselect", function(event) {
	var section = $(event.target);
	var type = section
	  .attr("class")
	  .replace("shopify-section", "")
	  .trim();
	var id = event.originalEvent.detail.sectionId;

	switch (type) {
	  case "js-section__mobile-draw":
		//jump back to to previous offset
		$(document).scrollTop(theme.currentOffset);
		$.magnificPopup.close();
		break;

	  case "js-section__age-checker":
		//jump back to to previous offset
		$(document).scrollTop(theme.currentOffset);
		$.magnificPopup.close();
		break;

	  case "js-section__promo-pop":
		theme.promoPop("close");
		//jump back to to previous offset
		$(document).scrollTop(theme.currentOffset);
		break;

	  case "js-section__home-slider":
		var currSlideshowSection = $('[data-section-id="' + id + '"]').find(
		  ".js-home-carousel"
		);
		//play carousel autoplay
		if (currSlideshowSection.data("autoplay")) {
		  currSlideshowSection.slick("slickPlay");
		}
		break;

	  case "js-section__home-testimonials":
		var currTestimonialsSection = $('[data-section-id="' + id + '"]').find(
		  ".js-home-testimonials-carousel"
		);
		//play carousel autoplay
		if (currTestimonialsSection.data("autoplay")) {
		  currTestimonialsSection.slick("slickPlay");
		}
		break;

	  case "js-section__product-testimonials":
		var currProdTestimonialsSection = $(
		  '[data-section-id="' + id + '"]'
		).find(".js-home-testimonials-carousel");
		//play carousel autoplay
		if (currProdTestimonialsSection.data("autoplay")) {
		  currProdTestimonialsSection.slick("slickPlay");
		}
		break;
	}
  })
  .on("shopify:block:select", function(event) {
	var id = event.originalEvent.detail.sectionId;
	var slide = $(event.target);
	var type = slide
	  .parents(".shopify-section")
	  .attr("class")
	  .replace("shopify-section", "")
	  .trim();

	switch (type) {
	  case "js-section__home-slider":
		var currSlideshowSlide = $(slide)
		  .find(".home-carousel__item")
		  .attr("data-slide-id");
		var currSlideshowSlider = $('[data-section-id="' + id + '"]').find(
		  ".js-home-carousel"
		);
		//go to slide
		currSlideshowSlider.slick("slickGoTo", currSlideshowSlide);
		break;

	  case "js-section__home-testimonials":
		var currTestimonialsSlide = $(slide)
		  .find(".home-testimonials__item")
		  .attr("data-slide-id");
		var currTestimonialsSlider = $('[data-section-id="' + id + '"]').find(
		  ".js-home-testimonials-carousel"
		);
		//go to slide
		currTestimonialsSlider.slick("slickGoTo", currTestimonialsSlide);
		break;

	  case "js-section__product-testimonials":
		var currProdTestimonialsSlide = $(slide)
		  .find(".home-testimonials__item")
		  .attr("data-slide-id");
		var currProdTestimonialsSlider = $(
		  '[data-section-id="' + id + '"]'
		).find(".js-home-testimonials-carousel");
		//go to slide
		currProdTestimonialsSlider.slick(
		  "slickGoTo",
		  currProdTestimonialsSlide
		);
		break;
	}
  });

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
	If that file is not included, it is redefined here.
==============================================================================*/
if (typeof Shopify === "undefined") {
  Shopify = {};
}
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
	var value = "",
	  placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
	  formatString = format || this.money_format;

	if (typeof cents == "string") {
	  cents = cents.replace(".", "");
	}

	function defaultOption(opt, def) {
	  return typeof opt == "undefined" ? def : opt;
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
	  precision = defaultOption(precision, 2);
	  thousands = defaultOption(thousands, ",");
	  decimal = defaultOption(decimal, ".");

	  if (isNaN(number) || number === null) {
		return 0;
	  }


	  number = (number / 100.0).toFixed(precision);

	  var parts = number.split("."),
		dollars = parts[0].replace(
		  /(\d)(?=(\d\d\d)+(?!\d))/g,
		  "$1" + thousands
		),
		cents = parts[1] ? decimal + parts[1] : "";

	  return dollars + cents;
	}

	switch (formatString.match(placeholderRegex)[1]) {
	  case "amount":
		value = formatWithDelimiters(cents, 2);
		break;
	  case "amount_no_decimals":
		value = formatWithDelimiters(cents, 0);
		break;
	  case "amount_with_comma_separator":
		value = formatWithDelimiters(cents, 2, ".", ",");
		break;
	  case "amount_no_decimals_with_comma_separator":
		value = formatWithDelimiters(cents, 0, ".", ",");
		break;
	}

	return formatString.replace(placeholderRegex, value);
  };
}

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */

(function detectIE() {
	var ieV;
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        ieV = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        document.querySelector('html').className += ' ie11';
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        ieV = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        document.querySelector('html').className += ' ie11';
    }

    // other browser
    return false;
})();

/*-----------------------------------------------------------------------------/
/ Video Playback
/-----------------------------------------------------------------------------*/
var videos = (function(){

  var settings = {
    cover: ".js-video-cover"
  }

  var init = function(){
    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    var iframe = $('iframe.vimeo-video') ;
    var playing = false;

    $(settings.cover).on( 'click', function () {
      $(this).find('img').fadeOut();
      $(this).addClass('fadeOut-before');
      var video = $(this).find('video');

      if (!playing) {
        video.trigger('play');
        playing = true;
      }

      if ( iframe.length > 0 ) {
        var player = new Vimeo.Player(iframe);

          player.play();
      }
    });
  }

  return {
      init: init
    }
})();


/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
if ($('#rc_container').length) {
  theme.normalizeReChargePrices();
}

$('.subscriber-gate').click(function(){
  $(this).fadeOut('slow');
})

var customSelect = (function(){
  var settings = {
    customSelect: ".js-custom-select",
    selectTrigger: ".js-custom-trigger",
    selectOption: ".js-custom-option",
    hiddenSelect: ".js-hidden-select"
  }

  var init = function(){
    if (!$(settings.customSelect).length) return;

    initializeEventListeners()
  }

  var initializeEventListeners = function(){
    $(settings.selectTrigger).on('click', toggleSelect);
    $(settings.selectOption).on('click', setActiveOption);
  }

  var toggleSelect = function(e){
    $(settings.customSelect).toggleClass('open');
  }

  var setActiveOption = function(e){
    var $this = $(this);
    var $otherOptions = $(settings.selectOption).not($this);
    var $selectContainer = $this.parents(settings.customSelect);
    var id = $selectContainer.data('for');
    var value = $this.data('value');

    $this.addClass("active");
    $otherOptions.removeClass("active");
    toggleSelect();

		if ($this.hasClass('og-filter-option')){
			// OG theme filtering logic
			if (value && location.pathname !== value) {
				location.href = value;
			}
		} else if ($this.hasClass('js-collection-sort-option')) {
			// NEW Collection Filtering logic
			collectionFilters.handleSort($this);
		}

  }

  return { init: init }
})();

const collectionFilters = (function(){
  const settings = {
    filterContainer					: 	".js-filter-container",
		filterToggleContainer 	:		".js-filter-toggle-container",
    filterToggle						: 	".js-filter-toggle",
    filterInputs						: 	".js-collection-filter",
		overlay               	:	 	".js-filter-overlay",
		productCard							: 	".js-product-card",
		accessibilityWidget			: 	".acsb-trigger",
		accordionTitle					: 	".js-accordion-title",
    accordionContent				: 	".js-accordion-content",
    accordionContainer			: 	".js-accordion",
    accordionGroup					: 	".js-accordion-group",
		resetFiltersBtn					: 	".js-reset-filters",
		selectedFilterContainer	:		".js-selected-filter",
		removeFilterTagBtn			:		".js-remove-filter-tag-btn",
		activeFilterCount				:		".js-active-filter-count",
		activeFilterDrawer			:		".js-active-filter-drawer"
  }

	let filters = {};
	let prevSort;
	let noResultsFoundHTML = `
		<div class="no-results-from-filter--container">
			<h3 class="gotham bold black uppercase size-42 u-mb-none">No Results Found</h3>
			<p class="din-next size-16">We're always brewing something new, but we haven't tried that combination yet! Check again soon, and in the meantime, try removing a filter or two to return more products! </p>
			<button type="button" name="reset" class="js-reset-filters active reset-filters no-results btn-transparent uppercase black gotham bold">
				<span class="sr-only">Reset Filters</span>
				<span class="din-next">RESET FILTERS</span>
			</button>
		</div>`

  const init = function(){
    if ($(settings.filterToggle).length === 0) return;

		getFilters();
    initializeEventListeners();
  }

  const initializeEventListeners = function(){
		$(document).on('click', settings.overlay, toggleFilterPanel);
		$(document).on('click', settings.resetFiltersBtn, function() {resetFilters()});
		$(document).on('click', settings.removeFilterTagBtn, function(e) {resetFilters(e)});
    $(settings.filterToggle).on('click', toggleFilterPanel);
		$(settings.accordionTitle).on('click', toggleAccordion);
		$(settings.filterInputs).on('click', handleFilterChange);
  }

	const addNoScroll = function(){
		// only add to no scroll if the body doesn't already have it!
		if (!$(document.body).hasClass('no-scroll')) {
			scrollY = window.pageYOffset;

			$(document.body).css({ top: -(scrollY) + "px" });
			$('html').addClass('no-scroll');
			$(document.body).addClass('no-scroll');
		}
	}

	const removeNoScroll = function(){
		$(document.body).removeClass('no-scroll');
		$(document.body).css({ top: '' });

		window.scrollTo(0, scrollY || 0);
		$('html').removeClass('no-scroll');
	}

	const toggleNoScroll = function(){
		if ($(document.body).hasClass('no-scroll')) {
			removeNoScroll()
		} else {
			addNoScroll()
		}
	}

	const getFilters = function() {
		let filterGroups = $(settings.accordionGroup);

		for (let i =0; i < filterGroups.length; i++) {
			filters[filterGroups[i].id] = [];
		}
	}

  const toggleFilterPanel = function(e){
		let $filterContainer = $(settings.filterContainer);
		let acsbWidget = $(settings.accessibilityWidget);
		let acsbOffset;
		if (acsbWidget?.length) {
			acsbOffset = parseInt(acsbWidget.css('left').replace('px', ''));
		}

    $filterContainer.toggleClass('active');

    if ($filterContainer.hasClass('active')) {
      $filterContainer.css('visibility', 'visible')
      $filterContainer.find('js-filter-toggle').focus()
			if (acsbWidget?.length) {
				acsbWidget.css({
					left: $filterContainer.width() + acsbOffset
				})
			}
    } else {
			if (acsbWidget?.length) {
				setTimeout(() => {
					$filterContainer.css('visibility', 'hidden')
				}, 500)
				acsbWidget.css({
					left: acsbOffset - $filterContainer.width()
				})
			}
    }
		toggleOverlay();
		toggleNoScroll();
  }

	var handleFilterChange = function(e){
    var $this = $(this);
    var filterGroup = $this.attr('name');
    var filterName = $this.val();
		let activeFiltersDrawer = $(settings.activeFilterDrawer);
		let activeFilterDrawerTagHTML = `
			<span class="active-filter js-remove-filter-tag-btn din-next black size-14" data-filter="${filterName}" data-category="${filterGroup}">
				<button class="btn-transparent">${filterName}
					<span class="sr-only">Remove ${filterName} Filter</span><svg xmlns="http://www.w3.org/2000/svg" width="7.707" height="7.707" viewBox="0 0 7.707 7.707">
						<g id="icon-x" transform="translate(-333.146 -1447.146)">
							<line id="Line_55" data-name="Line 55" x2="7" y2="7" transform="translate(333.5 1447.5)" fill="none" stroke="#000" stroke-width="1"></line>
							<line id="Line_56" data-name="Line 56" x2="7" y2="7" transform="translate(333.5 1454.5) rotate(-90)" fill="none" stroke="#000" stroke-width="1"></line>
						</g>
					</svg>
				</button>
			</span>
			`

    if (filters[filterGroup].includes(filterName)) {
			if ($this.attr("type") === "checkbox") {
        // remove clicked filter from active filters array
        filters[filterGroup] = filters[filterGroup].filter(function(item) {
          return item !== filterName
        })
        // remove clicked filter tag from active filters drawer
        let activeFilter = activeFiltersDrawer.find(`.active-filter[data-filter="${filterName}"]`);
        activeFilter.remove();

      } else if ($this.attr("type") === "radio") {
        if (filters[filterGroup][0] === $this.val()) {
					// if clicked radio filter === the only filter in the active filters array
					return;
				} else {
          // remove clicked filter from active filters array
          filters[filterGroup] = filters[filterGroup].filter(function(item) {
            return item !== filterName;
          })
          // remove clicked filter tag from active filters drawer
          let activeFilter = activeFiltersDrawer.find(`.active-filter[data-filter="${filterName}"]`);
          activeFilter.remove();
        }
      }
    } else {
			// add clicked filter to active filters drawers
			if ($this.attr("type") === "radio") {
				if (filters[filterGroup].length > 0 && filters[filterGroup][0] !== $this.val()) {
					let radioTagPartner = $(`.active-filter[data-filter="${filters[filterGroup][0]}"]`);
					radioTagPartner.remove();
					filters[filterGroup].shift();
					activeFiltersDrawer.append(activeFilterDrawerTagHTML);
				} else {
					activeFiltersDrawer.append(activeFilterDrawerTagHTML);
				}
			} else {
				activeFiltersDrawer.append(activeFilterDrawerTagHTML);
			}

			// add clicked filter to active filters array
			filters[filterGroup].push(filterName);
    }

    filterProducts(filters)
  }

	const resetFilters = function(e){
		if (e === undefined) {
			// if no argument provided, reset ALL filters
			$(settings.filterInputs + ":checked").click();
			$(settings.filterInputs + ":checked").prop('checked', false);
			$(settings.removeFilterTagBtn).remove();
			$(settings.selectedFilterContainer).removeClass('active');

			// empty filters array of any remaining active filters
			for (const filterGroup in filters) {
				let tagArray = filters[filterGroup];
				tagArray.length = 0;
			}
		} else {
			// if (optional) filter target is passed as argument, remove only that filter
			let targetTag = e.currentTarget;
			let targetCategory = targetTag.dataset.category;
			let targetFilter = targetTag.dataset.filter;
			let targetElement = $(settings.filterInputs + ":checked" + "[data-title='" + targetFilter + "'")

			targetElement.prop('checked', false);
			targetTag.remove();
			// remove filter from corresponding active filters array
			filters[targetCategory] = filters[targetCategory].filter(function(item) {
				return item !== targetFilter
			})
		}
		// Refilter using newly updated filters array
		filterProducts(filters);
  }

	const getActiveFilters = function() {
		let activeFilters = $('.js-collection-filter:checked');
		let totalActiveFilters = activeFilters.length;
		let filterToggleContainer = $(settings.filterToggleContainer);
		let resetBtns = $(settings.resetFiltersBtn);
		let activeFiltersCountContainer = $(settings.activeFilterCount);
		let activeFiltersDrawer = $(settings.activeFilterDrawer);

		if (totalActiveFilters === 0) {
			// no active filters, remove active states
			filterToggleContainer.removeClass('active');
			resetBtns.removeClass('active');
			activeFiltersCountContainer.text(totalActiveFilters);
		} else {
			// some active filters, add/keep active states
			activeFiltersCountContainer.text(totalActiveFilters);
			filterToggleContainer.addClass('active');
			resetBtns.addClass('active');
			if (totalActiveFilters > 2) {
				let drawerWidth = activeFiltersDrawer.width();
				activeFiltersDrawer.css('overflow-x', 'scroll')
				activeFiltersDrawer.css('max-width', drawerWidth)
			} else {
				activeFiltersDrawer.css('max-width', 'unset')
				activeFiltersDrawer.css('overflow-x', 'unset')
			}
		}
	}

	const handleSort = function($this) {
		if (prevSort !== $this.data('value')) {
			filterProducts(filters)
		}
	}

	const handleFilterNametags = function(filters){
		// handle selected filter tags
		for (const filterGroup in filters) {
			let tagArray = filters[filterGroup];
			let selectedTagContainer = $(settings.selectedFilterContainer + '[data-category="' + filterGroup + '"]');

			if (tagArray.length === 0) {
				// if 0 active filters in group
				selectedTagContainer.removeClass('active');
			} else if (tagArray.length === 1) {
				// if 1 active filter in group
				selectedTagContainer.text(tagArray[0])
				selectedTagContainer.addClass('active');
			} else if (tagArray.length > 1) {
				// if more than 1 active filter in group
				selectedTagContainer.text(`${tagArray.length} SELECTED`)
			}
		}
	}

	const filterProducts = function(filters){
		// 1.) Build URL based on:
		// • Active Filters --> filterURL
		// • Active Sort --> sortURL
		// 2.) Use URL to make request to Section Rendering API
		// 3.) Update filter nametags
		// 4.) Check for remaining activeFilters

		// 1a.) build filterURL snippet
		let activeFilters = $('.js-collection-filter:checked');
		let filterURL;

		for (let i =0; i < activeFilters.length; i++) {
			let filterHTMLElement = activeFilters[i];
			let filterURLSnippet = filterHTMLElement.dataset.title;
			let filterURLNormalizedSnippet = filterURLSnippet.replaceAll(' ', '-');
			if (i === 0) {
				filterURL = filterURLNormalizedSnippet
			} else {
				filterURL += "+"+filterURLNormalizedSnippet;
			}
		}
		if (filterURL === undefined) {
			filterURL = ''
		}

		// 1b.) build sortURL snippet
		let activeSort = $('.js-collection-sort-option.active').data('value');
		prevSort = activeSort;
		let sortURL;
		if (activeSort === undefined) {
			// default sort
			sortURL = 'manual';
		} else if (activeSort === "Best Sellers") {
			sortURL = 'best-selling';
		} else if (activeSort === "Latest Released") {
			sortURL = 'created-descending';
		} else if (activeSort === "First Released") {
			sortURL = 'created-ascending';
		} else if (activeSort === "Default Sorting") {
			// default sort
			sortURL = 'manual';
		}

		// 2.) use URL snippets to make request to Section Rendering API
		let pathname = window.location.pathname;
		let collectionGridURL = `${pathname}/${filterURL}?sections=collection-grid&sort_by=${sortURL}`
		$.ajax(collectionGridURL).then(function(response){
				if (response['collection-grid']) {
					let $response = $(response['collection-grid'])
					let parentContainer = $('#collection-main');
					let $newInnerHTML = $response.find('.collection-products');

					if ($newInnerHTML.children().length === 0) {
						parentContainer.html(noResultsFoundHTML)
					} else {
						parentContainer.html($newInnerHTML)
						$('.product-top').css('visibility', 'visible');
					}
				}
		})
		.catch(function(){})

		// 3.) update filter nametags
		handleFilterNametags(filters);

		// 4.) check for remaining activeFilters
		getActiveFilters();
  }

	const toggleOverlay = function() {
		let overlay = $(settings.overlay);

		if (overlay.hasClass("active")) {
			overlay.removeClass("active");
		} else {
			overlay.css({
				top: 0
			});
			overlay.addClass("active");
		}
	}

	const toggleAccordion = function() {
    let $container = $(this).parents(settings.accordionContainer);
    let $currentTitle = $(this).find('a');
    let $currentContent = $(this).next(settings.content);

    if ($currentTitle.attr('aria-expanded') == 'false'){
      let $activeTitle = $container.find('[aria-expanded=true]');
      let $activeContent = $container.find('[aria-hidden=false]');

      // closes any active titles
      $activeTitle.attr('aria-expanded' , false ).removeClass(settings.activeClass);
      // closes any active content
      $activeContent.slideUp(200).attr('aria-hidden' , 'true');

      // opens new content
      $currentTitle.attr('aria-expanded' , true).addClass('active');
      $currentContent.slideDown(200).attr('aria-hidden' , 'false');
    } else {
      // close the clicked content
      $currentTitle.attr('aria-expanded' , false ).removeClass('active');
      $currentContent.slideUp(200).attr('aria-hidden' , 'true');
    }
    // No Boing Boing
    return false;
  };

	return {
		init: init,
		handleSort: handleSort
	};
})()

// TS | Hops Tabs
var hopsTabs = (function(){
  var settings = {
    tabs: '.js-hoppiness-tab',
    contentPanels: '.js-hoppiness-content-panel'
  }

	function init() {
		$(settings.tabs).click(handleTabClick);
	}

  function handleTabClick(e){
		var $this = $(this)

		// toggle active tab
		if ($this.hasClass('active')) {
			return;
		} else {
			$(settings.tabs).removeClass('active');
			$this.addClass('active');
		}

		// toggle active panel
		var activeTab = $this.data('tab');
		var activeContentPanel = $(settings.contentPanels + '[data-content-panel="' + activeTab +'"]');
		$(settings.contentPanels).removeClass('active');
		activeContentPanel.addClass('active');
  }

  return { init: init };
})();


// TS: Sticky PDP ATC
function stickyATCInit () {
	if (window.location.href.indexOf("/products") > -1) {

		var $stickyATCContainer = $('.js-sticky-add');
		var footerOffset = $('#shopify-section-footer').offset().top;

		$(window).on('scroll', function(e){
			var $gorgiasWidget = $('#gorgias-chat-container iframe');
			var $accessibilityWidget = $('.acsb-ready');

			if (window.screen.availWidth > 320) {
				if (window.scrollY < 175) {
					$stickyATCContainer.removeClass('active');
					$gorgiasWidget.removeClass('shift-upwards');
					$accessibilityWidget.removeClass('shift-upwards');
				} else if ((window.scrollY - 1000) > $(".product-buy-panel").position().top) {
					$stickyATCContainer.addClass('active');
					$gorgiasWidget.addClass('shift-upwards');
					$accessibilityWidget.addClass('shift-upwards');
				} else {
					$stickyATCContainer.removeClass('active');
					$gorgiasWidget.removeClass('shift-upwards');
					$accessibilityWidget.removeClass('shift-upwards');
				}
			} else {
				$stickyATCContainer.removeClass('active');
				$gorgiasWidget.removeClass('shift-upwards');
				$accessibilityWidget.removeClass('shift-upwards');
			}

			if ((footerOffset - window.scrollY) < 2000) {
				$stickyATCContainer.removeClass('active');
				$gorgiasWidget.removeClass('shift-upwards');
				$accessibilityWidget.removeClass('shift-upwards');
			}

		})
	}
};

const loyaltyLionActivities = (function(){

  const init = function(){
    initializeEventListeners();
  }

  const initializeEventListeners = function(){
		let klaviyoSignupForm = $('form[data-testid="klaviyo-form-RkXmXJ"]')
		let smsSubmitBtn = klaviyoSignupForm.find('button:contains("Sign up")')
		$(document).on('click', smsSubmitBtn, handleSMSSignup);
  }

  const handleSMSSignup = function(){
		let klaviyoSignupForm = $('form[data-testid="klaviyo-form-RkXmXJ"]')
		let smsSubmitBtn = klaviyoSignupForm.find('button:contains("Sign up")')
		if (smsSubmitBtn && smsSubmitBtn.length > 0) {

			var settings = {
				"url": "https://hoptea-app.herokuapp.com//loyaltylion/track_sms_signup",
				"method": "POST",
				"data": {
					"name": "sms_signup",
					"customer_id": "{{customer.id}}",
					"customer_email": "{{customer.email}}"
				},
			};

			$.ajax(settings).done(function (response) {
				console.log('response:', response);
			});
		}
  }

  return {
    init
  }
})()

const profilePanelMenus = (function(){
  const settings = {
    tabBtn: ".js-tab-heading",
    tabContent: ".js-tab-content",
    activeProfileSpan: ".js-active-profile",
		profilePanelsContainer: '.js-profile-panels',
		shopActiveCollectionBtn: '.js-show-active-products',
		shopCollectionPanel: '.js-collection-purchase-panel',
		closeCollectionPanelBtn: '.js-collection-purchase-panel-close',
    cycleProfilesBtn: ".js-profile-cycle-btn",
		mobileMenuTrigger: ".js-custom-select-trigger",
		mobileMenuOption: ".js-profiles-custom-option",
		defaultDropdownOptionSpan: '.js-default-select-option-span',
    defaultDropdownOption: '.js-default-select-option',
		hiddenSelect: ".js-hidden-select",
		customSelect: ".js-custom-select"
  }

  const init = function(){
    if ($(settings.tabBtn).length === 0) return;

    initializeEventListeners();
    $(settings.tabBtn).first().click()
  }

  const initializeEventListeners = function(){
    $(settings.tabBtn).on('click', openTabContent);
    $(settings.cycleProfilesBtn).on('click', cycleActiveProfile);
		$(settings.mobileMenuTrigger).click(toggleSelect);
		$(settings.mobileMenuOption).click(setActiveProfileFromDropdown);
		$(settings.shopActiveCollectionBtn).click(openPurchasePanel);
		$(settings.closeCollectionPanelBtn).click(closePurchasePanel);
  }

  const openTabContent = function(e){
    let $this = $(this);
    let sectionHandle = $this.data('section');
    let sectionTitle = $this.data('title');
		let sectionCollection = $this.data('collection')
		let activeCollectionBtn = $(settings.shopActiveCollectionBtn);
		let defaultOptionSpan = $(settings.defaultDropdownOptionSpan);
    let defaultOption = $(settings.defaultDropdownOption);
		let parentPanelsContainer = $(settings.profilePanelsContainer);
		let collectionPurchasePanels = $(settings.shopCollectionPanel);
		let profilesTag = $('.js-profiles-heading-tag');

    $(settings.tabBtn).removeClass('active');
    $this.addClass('active');
		activeCollectionBtn.attr('data-section', sectionHandle)
		activeCollectionBtn.attr('data-collection', sectionCollection)
		activeCollectionBtn.removeClass('active');
		parentPanelsContainer.removeClass('active');
		collectionPurchasePanels.removeClass('active');

    let $activeSection = $(`${settings.tabContent}[data-section="${sectionHandle}"]`);

    $(settings.tabContent).removeClass('active');
		profilesTag.show();
    $activeSection.addClass('active');

    $(settings.activeProfileSpan).text(sectionTitle);

		// Update Mobile Dropdown
		defaultOption.attr('data-section', sectionHandle)
		defaultOption.attr('data-title', sectionTitle)
		defaultOptionSpan.text(sectionTitle)
  }

	const openPurchasePanel = function(e){
    let $this = $(this);
		let collectionHandle = $this.attr('data-collection');
		let sectionHandle = $this.attr('data-section');
		let activeCollectionBtn = $(settings.shopActiveCollectionBtn);
		let collectionPanels = $(settings.shopCollectionPanel);
		let parentPanelsContainer = $(settings.profilePanelsContainer);
		let $activeSection = $(`${settings.tabContent}[data-section="${sectionHandle}"]`);
		let $activeCollectionPanel = $(`[data-collection-purchase-panel="${collectionHandle}"]`);
		let profilesTag = $('.js-profiles-heading-tag');

		if ($this.hasClass('active')) {
			parentPanelsContainer.removeClass('active');
			collectionPanels.removeClass('active');
			activeCollectionBtn.removeClass('active');
			$activeSection.addClass('active');
			profilesTag.show();
		} else {
			collectionPanels.removeClass('active');
			profilesTag.hide();
			$activeSection.removeClass('active');
			parentPanelsContainer.addClass('active');
			activeCollectionBtn.addClass('active');
			$activeCollectionPanel.addClass('active');
		}
  }

	const closePurchasePanel = function(e){
		let $this = $(this);
		let sectionHandle = $this.data('section');
		let activeCollectionBtn = $(settings.shopActiveCollectionBtn);
		let parentPanelsContainer = $(settings.profilePanelsContainer);
		let $activeSection = $(`${settings.tabContent}[data-section="${sectionHandle}"]`);
		let collectionPanels = $(settings.shopCollectionPanel);
		let profilesTag = $('.js-profiles-heading-tag');

		collectionPanels.removeClass('active');
		activeCollectionBtn.removeClass('active');
		parentPanelsContainer.removeClass('active');
		$activeSection.addClass('active');
		profilesTag.show();
	}

  const cycleActiveProfile = function(e){
    let cycleDirection = $(this).attr('name');
    let $activeBtn = $(`${settings.tabBtn}.active`);
    let currentIndex = $(settings.tabBtn).index($activeBtn);
    let allBtns = $(settings.tabBtn);
		let defaultOptionSpan = $(settings.defaultDropdownOptionSpan);
    let defaultOption = $(settings.defaultDropdownOption);
		let collectionPanels = $(settings.shopCollectionPanel);
    let $newActiveBtn;

    if (cycleDirection === "next") {
      $newActiveBtn = allBtns.eq(currentIndex + 1)
      if ($newActiveBtn.length === 0) {
        $newActiveBtn = allBtns.eq(0)
      }
    } else if (cycleDirection === "previous") {
      if ($activeBtn === allBtns.first()) {
        $newActiveBtn = allBtns.last()
      } else {
        $newActiveBtn = allBtns.eq(currentIndex - 1)
      }
    }

    if ($newActiveBtn) {
			// Update Desktop List
      $newActiveBtn.trigger('click')

			// Update Mobile Dropdown
			defaultOption.data('section', $newActiveBtn.data('section'))
			defaultOption.data('title', $newActiveBtn.data('title'))
			defaultOptionSpan.text($newActiveBtn.data('title'))
    }
  }

	const toggleSelect = function() {
		$(settings.customSelect).toggleClass('open');
	}

	const setActiveProfileFromDropdown = function() {
		let $this = $(this);
    let sectionHandle = $this.data('section');
    let sectionTitle = $this.data('title');
		let sectionCollection = $this.data('collection')
		let activeCollectionBtn = $(settings.shopActiveCollectionBtn);
		let collectionPurchasePanels = $(settings.shopCollectionPanel);
		let parentPanelsContainer = $(settings.profilePanelsContainer);

    let defaultOptionSpan = $(settings.defaultDropdownOptionSpan);
    let defaultOption = $(settings.defaultDropdownOption);
		let allBtns = $(settings.tabBtn);
		let $newActiveBtn = $(`.js-tab-heading[data-section="${sectionHandle}`)
		let $activeSection = $(`${settings.tabContent}[data-section="${sectionHandle}"]`);

		$(settings.tabContent).removeClass('active')
    $activeSection.addClass('active');
		activeCollectionBtn.attr('data-section', sectionHandle)
		activeCollectionBtn.attr('data-collection', sectionCollection);
		collectionPurchasePanels.removeClass('active');
		parentPanelsContainer.removeClass('active');

    $(settings.activeProfileSpan).text(sectionTitle);
		defaultOption.attr('data-section', sectionHandle);
		defaultOption.attr('data-title', sectionTitle);
		defaultOptionSpan.text(sectionTitle);
		allBtns.removeClass('active');
		$newActiveBtn.addClass('active');
		toggleSelect();
	}

  return {
    init
  }
})()

// +++++++++++++++++++++
// TS: Video Players
// +++++++++++++++++++++

const inlineVideoPlayer = (function(){
  let settings = {
    videoWrapper: '[data-video-player]',
    controls: '[data-video-controls]',
    video: 'video[data-video]',
    playBtn: '[data-video-play]',
    pauseBtn: '[data-video-pause]'
  }

	const elementsExist = (elements = []) => {
		return elements.filter(el => el.length).length == elements.length;
	}

  const init = () => {
    let $videoWrapper = $(settings.videoWrapper)
    if (elementsExist( [ $videoWrapper ] )) {

      $videoWrapper.each(function(index, wrapper){
        videoControls($(wrapper), settings)
      })

    }
  }

  return { init }
})()

const videoControls = (function($wrapper, settings){
  const cache = {
    $controls: $wrapper.find(settings.controls),
    $video: $wrapper.find(settings.video),
    $playBtn: $wrapper.find(settings.playBtn),
    $pauseBtn: $wrapper.find(settings.pauseBtn)
  }

  const initEventListeners = function(){
    cache.$playBtn.on('click', playPauseVideo);
    cache.$pauseBtn.on('click', playPauseVideo);

    if (cache.$video[0]) {
      cache.$video[0].addEventListener('ended', handleVideoEnd, false);
    }
  }

  const handleVideoEnd = function(){
    $wrapper.removeClass('activated')
  }

  const playPauseVideo = function(e){
    let video = cache.$video[0];

    if (!video) {
			return;
		} else if(window.getComputedStyle(video).display === "none") {
			video = cache.$video[1];
		}

    if (video.paused) {
      video.play()
      $wrapper.addClass('activated')

      cache.$pauseBtn.focus()
    } else {
      video.pause()
      $wrapper.removeClass('activated')

      cache.$playBtn.focus()
    }
  }

  initEventListeners()
})

var overlayVideoPlayer = (function(){
  var settings = {
    videoTrigger: ".js-video-trigger",
    videoWrapper: ".js-video-wrapper"
  }

  var videoPlayer; // for vimeo
  var player; // for youtube
  var focusTriggerElement;

  var iframe;

  const delta = 6;
  let startX;
  // let startY;

  var init = function(){
    if ($(settings.videoWrapper).length === 0) return;

		loadScript();
    initializeEventListeners();
    slickImages();
  }

	var initializeEventListeners = function(){
    $(settings.videoWrapper).on('click', function(e){toggleVideoWrapper(e, this)});
    $(settings.videoTrigger).on('mousedown', trackMouseMovement);
    $(settings.videoTrigger).on('click', confirmClick);
    $(settings.videoTrigger).on('keydown', confirmClick);
    $(settings.videoWrapper).on('keydown', listenForEscape);
  }

	const loadScript = function() {
		if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
				var tag = document.createElement('script');
				tag.src = "https://www.youtube.com/iframe_api";
				var firstScriptTag = document.getElementsByTagName('script')[0];
				firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}
	}

	const addNoScroll = function(){
		if (!$(document.body).hasClass('no-scroll')) {
			scrollY = window.pageYOffset;

			$(document.body).css({ top: -(scrollY) + "px" });
			$('html').addClass('no-scroll');
			$(document.body).addClass('no-scroll');
		}
	}

	const removeNoScroll = function(){
		$(document.body).removeClass('no-scroll');
		$(document.body).css({ top: '' });

		window.scrollTo(0, scrollY || 0);
		$('html').removeClass('no-scroll');
	}

  var trackMouseMovement = function(e){
    startX = e.pageX;
    startY = e.pageY;
  }

	var trapUserFocus = function() {
    $(window).on('keydown', cycleFocusableVimeoElements);
  }

  var returnFocusToParent = function() {
    // if (focusTriggerElement.length) {
    //   focusTriggerElement.focus()
    // }
  }

  var setFocusToDoc = function(){
    $(window).focus();
  }

  var onPlayerReady = function(event) {
      event.target.playVideo();
			console.log('onPlayerReady!!')
  }

  var goToImage = function(imageId){
    var $slider = $('.js-image-lightbox');

    if ($slider.length) {
      var image = $slider.find('img[data-id="' + imageId + '"]').parents('.slick-slide').not('.slick-cloned');
      let slides = $slider.find('.slick-slide').not('.slick-cloned')
      // let index = slides.index(image);
      let index = image.index() - 1

      $slider.slick('slickGoTo', index, true);
    }
  }

  var toggleVideoWrapper = function(e, self){
    e.preventDefault();
    e.stopPropagation();

    var $target = $(e.target);

    var $this = $(self);

    var target = $this.data('target');
    var imageId = $this.data('id');

    var $section = $(settings.videoWrapper + '[data-target="' + target + '"]');

    if (!$section.hasClass("active")) {

      focusTriggerElement = $this
      $section.addClass('active').show();
      $section.attr('aria-hidden', false)
      $(window).on('keydown', listenForEscape);
      iframe = $section.find("iframe");
      trapUserFocus(e);
      $section.find('.video--close-button').focus()

      var source = iframe.attr('src');
			addNoScroll()

      if (source && source.includes("vimeo")) {
        if (iframe.length) {
          videoPlayer = new Vimeo.Player(iframe);

          videoPlayer.on('play', setFocusToDoc);
        }
      } else if (source && source.includes('youtube')) {

        var videoId = source.split("embed/")[1]

        if (videoId && videoId.includes("?")) {
          videoId = videoId.split("?")[0];
        }
        if (videoId) {

          if ( player && player.h && player.h.id === videoId ) {

					} else if (YT && YT.Player) {
						var player = YT.get('video-overlay-hero');
						player.playVideo();
          }
        }
      }
    } else {
      if ($target.hasClass('js-video-wrapper') || $this.hasClass('js-video-trigger')) {
				var player = YT.get('video-overlay-hero');
        closeVideoWrapper(player);
        $section.attr('aria-hidden', true)
      }
    }

    if (imageId) {
      goToImage(imageId);
    }
  }

  var confirmClick = function(e){
    e.preventDefault();
    const diffX = Math.abs(e.pageX - startX);
    const diffY = Math.abs(e.pageY - startY);

    if (e.keyCode === 13 || e.keyCode === 32) {
      toggleVideoWrapper(e, this);
    }

    if (diffX < delta && diffY < delta) {
      toggleVideoWrapper(e, this);
    }

    if ($(this).hasClass('video--close-button')) {
      returnFocusToParent();
    }
  }

  var closeVideoWrapper = function(player){
    if (videoPlayer) {
      videoPlayer.pause().then(function(){
        var $section = $(settings.videoWrapper + ".active");
        $section.removeClass('active').hide();

        removeNoScroll();
      });
    } else if (player) {
			// player.pauseVideo();
			
      if (window.player && window.player.pauseVideo) {
        player.pauseVideo();
      } else {
				document.querySelectorAll('iframe').forEach(v => {
					v.src = v.src
				});
				document.querySelectorAll('video').forEach(v => {
					v.pause()
				});
			}
      var $section = $(settings.videoWrapper + ".active");
      $section.removeClass('active').hide();
      removeNoScroll();
    } else {
      var $section = $(settings.videoWrapper + ".active");
      $section.removeClass('active').hide();
      removeNoScroll();
    }

    $(window).off('keydown', cycleFocusableVimeoElements);
    returnFocusToParent();
  }

	var listenForEscape = function(e){
    if (e.keyCode === 27) {
      closeVideoWrapper(e);
    }
  }

  var cycleFocusableVimeoElements = function(e) {
    var modal = document.querySelector('.js-video-wrapper');
    var firstFocusableElement = modal.querySelector('.js-video-trigger.video--close-button');

    if(e.target === firstFocusableElement && e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
    } else if ($(e.target).parents('.js-video-wrapper').length === 0 && e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  }

  var slickImages = function(){
    var settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false
    }

    $('.js-image-lightbox').slick(settings);
  }

  return {
    init: init
  }
})()


const subscriptionPermalinks = (function(){
  // Shopify.queryParams
  const settings = {
    subscriptionParam: 'subs',
    oneTimeParam: 'otps',
		discountParam: 'discount'
  }

  const splitParams = function(value){
		if (value != undefined) {
			return value.split(',')
		}
  }

  const clearCart = function(callback){
		ShopifyAPI.clearCart(callback);
  }

  const parseVariantString = function(variantString){
    let splitStr = variantString.split(':')
    let id = parseInt(splitStr[0]);
    let quantity = parseInt(splitStr[1]);

    return {
      id,
      quantity
    }
  }

  const addSubscriptionProperties = function(item){
		// HTC Monthly • Caffeinated --> 42098779062430
		// HTC Monthly • No Caffeine --> 42098779095198
		// HTC Annual • Caffeinated --> 42098798330014
		// HTC Annual • No Caffeine --> 42098798362782
		let properties = {
			shipping_interval_frequency: 1,
			shipping_interval_unit_type: "Months"
		}

    item.properties = properties;

    return item;
  }

  const buildCartItems = function(){
    let allItems = []

    let subscriptions = splitParams(Shopify.queryParams[settings.subscriptionParam])
    let oneTimes = splitParams(Shopify.queryParams[settings.oneTimeParam])

		if (subscriptions && oneTimes) {
			let mappedSubs = subscriptions
												.map(parseVariantString)
												.map(addSubscriptionProperties);
			let mappedOneTimes = oneTimes.map(parseVariantString)
	
			return mappedSubs.concat(mappedOneTimes);
		} else {
			let mappedSubs = subscriptions
												.map(parseVariantString)
												.map(addSubscriptionProperties);
			return mappedSubs;
		}
  }

  const addItemsToCart = function(itemData, callback){
		jQuery.post('/cart/add.js', {
			items: itemData
		}).then(function(){
			callback()
		});
  }

  const processCheckout = function(){
		let discount = Shopify.queryParams[settings.discountParam]

		if (discount && discount.length) {
			ShopifyAPI.getCart((cart) => {
				let rechargeURL = reChargeProcessCart();
				location.href = rechargeURL + `&discount=${discount}`
			})
		} else {
			ShopifyAPI.getCart((cart) => {
				location.href = reChargeProcessCart();
			})
		}
  }

  const init = function(){
    if (Shopify.queryParams[settings.subscriptionParam] || Shopify.queryParams[settings.oneTimeParam]) {
      // generate items to add
      let items = buildCartItems();
      // start with a clear cart
      // add all items from query params at once
      // redirect to ReCharge checkout

      clearCart(() => {
        addItemsToCart(items, processCheckout);
      })
    }
  }

  return { init }
})()

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-slide-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

//ReCharge Redirect past store cart

// window.reChargeProcessCart = function(e) {
//   	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }

//   	do {
//       token=get_cookie('cart');
//   	}
//     while(token == undefined);
//     var myshopify_domain = Shopify.shop
//     try {
//       var ga_linker = ga.getAll()[0].get('linkerParam')
//     } catch(err) {
//       var ga_linker = '' ;
//     }

//     var april = new Date('2021-04-01')
//     var today = new Date();
//     var discountParam = "";
//     if (today < april) {
//       var cameFromUrl = sessionStorage.getItem('discount');
//       if (cameFromUrl) {
//         discountParam = "&discount=2021EXTRA10"
//       }
//     }

//     var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}'
//     var url = "https://checkout.hoplark.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker + discountParam + "&" + customer_param;
//     url = url.replace('&&', '&');
//   	return url
// }

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/update.js',
        data: 'note=' + attributeToString(note),
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeUpdateCartNote.ajaxCart', note);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};
ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery(form).serialize(),
        dataType: 'json',
        beforeSend: function(jqxhr, settings) {
          $body.trigger('beforeAddItem.ajaxCart', form);
        },
        success: function(line_item) {

          if ($(form).hasClass("js-limit-1")) {
            // hide the add to cart button and show the limit message.
            $('.js-product-buttons').addClass('hide');
            $('.js-limit-message').removeClass('hide');
          }

          if ((typeof callback) === 'function') {
            callback(line_item, form);
          } else {
            ShopifyAPI.onItemAdded(line_item, form);
          }

          // TS: pixel-helper.js.liquid | pixelAdapter.addToCart(line_item)
          pixelAdapter.addToCart(line_item);

					// TS: Klaviyo "Added to Cart" Script
					var _learnq = _learnq || [];
					_learnq.push(['track', 'Added to Cart', line_item]);

					if ($(form).hasClass('js-reco-product-form')) {
						return;
					} else {
						$body.trigger('afterAddItem.ajaxCart', [line_item, form]);
					}
        },
        error: function(XMLHttpRequest, textStatus) {
          if ((typeof errorCallback) === 'function') {
            errorCallback(XMLHttpRequest, textStatus);
          }
          else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
          $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  		jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {

    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
      params = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        beforeSend: function() {
          $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
        },
        success: function(cart) {
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            ShopifyAPI.onCartUpdate(cart);
          }
          $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
        },
        error: function(XMLHttpRequest, textStatus) {
          $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        },
        complete: function(jqxhr, text) {
          $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
        }
      };
  jQuery.ajax(params);
};

ShopifyAPI.clearCart = function(callback){
  var params = {
    type: 'POST',
    dataType: 'json',
    url: '/cart/clear.js',
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
}


var removeBundlesFromCart = function(cart){
  var originalCart = sessionStorage.getItem('originalCart');
  if (originalCart) {
    originalCart = JSON.parse(originalCart);
    processOriginalCart(cart)
    // ShopifyAPI.getCart(processOriginalCart);

    function processOriginalCart(cart) {
      var itemsToAdd = []
      var updates = {};

      cart.items.forEach(item => {
        if (item.properties["Bundle #"]) {
          updates[item.key] = 0
        }
      })


      originalCart.items.forEach(item => {
        var propertyKeys = Object.keys(item.properties);
        var itemIsBundle = false;

        propertyKeys.forEach(key => {
          if (key[0] === ("_")) {
            itemIsBundle = true;
          }
        })

        if (itemIsBundle) {
          var newItem = {
            id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties
          }

          itemsToAdd.push(newItem);
        }
      })

      if (Object.keys(updates).length) {
        jQuery.post('/cart/update.js', {
          updates: updates
        }).then(function(){
          jQuery.post('/cart/add.js', {
            items: itemsToAdd
          }).then(function(json){
            sessionStorage.removeItem('originalCart');
            ShopifyAPI.getCart(ajaxCart.adjustCart);
          });
        })
      }
    }
  }
}

// +++++++++++++++++++++
// Marquee
// +++++++++++++++++++++
const marquee = {
  settings: {
    marquee: '.js-marquee',
    inner: '.js-marquee-inner',
    initializedClass: 'marquee-initialized',
    breakpoint: 768
  },

  init: function() {
    this.initializeObjects();
    this.initializeAll();
  },

  initializeObjects: function() { // create an object for each marquee
    this.all = {};
    const marquee = this;

    $(this.settings.marquee).each(function(i) {
      $(this).data('marquee', i);
      const ID = 'marquee' + i;

      const contentQuantity = $(this).find(marquee.settings.inner + ' > *').length;
      const marqueeWidth = $(this).find(marquee.settings.inner)[0].scrollWidth;

      const obj = {
        animationFrame: null,
        allowedLength: contentQuantity - 1,
        width: marqueeWidth
      };

      marquee.all[ID] = obj;
    });
  },

  getObject: function($marquee) {
    const ID = $marquee.data('marquee');
    return this.all['marquee' + ID];
  },

  initializeAll: function() { // check for responsiveness setting
    const marquee = this;

    $(this.settings.marquee).each(function() {
      const $marquee = $(this);

      marquee.alert($marquee);
    });
  },

  alert: function($marquee) { // trigger/kill, dependant on screen size/resize
    $(window).on('resize', () => this.handleResize($marquee));
    this.handleResize($marquee);
  },

  handleResize: function($marquee) {
    if ( window.innerWidth >= marquee.settings.breakpoint || $marquee.hasClass('js-mobile-marquee') ) {
      const ensureNoSlider = setInterval(() => {
        if ( !$marquee.find('.js-marquee-inner').hasClass('slick-slider') ) {
          clearInterval(ensureNoSlider);
          marquee.trigger($marquee);
        }
      }, 100);
    } else {
      this.kill($marquee);
    }
  },

  trigger: function($marquee) {
    if ( $marquee.hasClass(this.settings.initializedClass) ) { return; }

    // Settings
    let speed = 1;

    const selfObj = this.getObject($marquee);
    const $inner = $marquee.find(this.settings.inner);
    const $content = $marquee.find(this.settings.inner + ' > *');

    // Duplicate content
    const $clone = $content.clone();
    $clone.appendTo($inner);

    let progress = 1;

    function loop() {
      progress = progress - speed;
      if ( progress <= selfObj.width * -1 ) {
        progress = 0;
      }

      $inner.css({ transform: `translateX(${ progress }px)` });

      selfObj.animationFrame = window.requestAnimationFrame(loop);
    }
    loop();

    $marquee.addClass(this.settings.initializedClass);
  },

  kill: function($marquee) { // Turn off marquee animation
    if ( !$marquee.hasClass(this.settings.initializedClass) ) { return; }

    const selfObj = this.getObject($marquee);
    window.cancelAnimationFrame(selfObj.animationFrame);

    this.cleanUp($marquee);
  },

  cleanUp: function($marquee) {
    const selfObj = this.getObject($marquee);
    const $inner = $marquee.find(this.settings.inner);

    // remove cloned nodes
    $inner.children().each(function(i) {
      if ( i > selfObj.allowedLength ) {
        $(this).remove();
      }
    });

    // reset affected elements
    $marquee.removeClass(this.settings.initializedClass);
    $inner.css({ 'transform': 'none' });
  }
}


/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';

  // Public functions
  var init, loadCart, getCart, initializeEventListeners, openSlideCart;

  // Private general variables
  var settings, isUpdating, $body, currentCart, scrollY, cartSettings, recommendations, recommendationsOverride, recommendedProductOverride;
  var cartNotesEnabled = true;
  var packSizeShouldRender = false;
  var packSize;
  var rechargePropsShouldRender = false;
  var productVendorAlternative;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $cartFooter, $drawerContainer, $emptySelector, $triggerSelector, $closeCartButton, last;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, getPromotion, cartCallback, adjustCart, adjustCartCallback, validateQty, loadCartSettings, loadProductRecommendations, selectRecommendationVariant, getRecommendedProduct, loadProductRecommendationsOverride, getRecommendedProductOverride, closeSlideCart, processCart, addNoScroll, removeNoScroll, toggleNoScroll, adjustItemQuantity, onCartUpdate, changeCart, updateCartCount, countBundleChildren, isProductADonation, handleBundlerATC, handleRemoveBundle;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      activeClass                   : 'active',
      overlay                       : '.js-overlay',
      cartLink                      : '.js-cart',
      closeCart                     : '.js-close-cart',
      cartRemove                    : '.js-remove-item',
			cartBundleRemove              : '.js-remove-bundle-item',
      ajaxCheckout                  : '.js-process-checkout',
      rechargeItems                 : '.js-recharge-item',
      recommendationScript          : '#recommendation-json',
      recommendationOverrideScript  : '#recommendation-overide-json',
      cartSettingsScript            : '#cart-settings-json',
      qtyAdjusters                  : '.js-adjust-qty',
      itemQty                       : '.js-item-qty',
      formSelector                  : 'form[action^="/cart/add"]',
      cartContainer                 : '.js-cart-container',
      CartFooter                    : '#CartFooter',
      addToCartSelector             : 'input[type="submit"]',
      cartCountSelector             : null,
      cartCostSelector              : null,
      triggerSelector               : null,
      emptySelector                 : '.ajaxcart--empty',
      moneyFormat                   : '${{amount}}',
      disableAjaxCart               : false,
      gorgiasWindow                 : 'iframe#chat-window',
      gorgiasWidget                 : 'iframe#chat-button',
			gorgiasCampaigns              : 'iframe#chat-campaigns',
			bundlerATC										: '.js-bundler-add-to-cart-btn'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $emptySelector     = $(settings.emptySelector);
    $triggerSelector   = $(settings.triggerSelector);
    $cartFooter        = $(settings.cartFooter);
    $closeCartButton   = $(settings.closeCart);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;
    loadCartSettings();
    loadProductRecommendationsOverride();
    loadProductRecommendations();
    getCart();
    formOverride();
    initializeEventListeners();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  initializeEventListeners = function() {
    $(document).on('click', settings.cartRemove, adjustItemQuantity);
    $(document).on('click', settings.cartBundleRemove, handleRemoveBundle);
    $(document).on('click', settings.qtyAdjusters, adjustItemQuantity);
    $(document).on('change', settings.itemQty, adjustItemQuantity);
    // $(document).on('click', settings.ajaxCheckout, processCart);
    $(document).on('click', settings.overlay + ", " + settings.closeCart, closeSlideCart);
    $(document).on('change', '.reco-variant-select', selectRecommendationVariant);
		$(document).on('click', settings.bundlerATC, handleBundlerATC);
  };

  processCart = function(e) {
    e.preventDefault();

    if ($(settings.rechargeItems).length) {
      var rechargeURL = window.reChargeProcessCart()
      location.href = rechargeURL
    } else {
      location.href = '/checkout'
    }
  }

	countBundleChildren = function(cart) {
		let bundleChildrenInCart = 0;

		cart.items.forEach(item => {
			var propertyKeys = Object.keys(item.properties);
			let itemIsPartOfBundle = propertyKeys.some(key => key.includes('Bundle #'));

			if (itemIsPartOfBundle) {
				bundleChildrenInCart += 1;
			}
		})
		return bundleChildrenInCart;
	}

  updateCartCount = function(cart){
		let bundleChildrenInCart = countBundleChildren(cart);

		// IF NO bundleChildren present in cart, count all items
		if (bundleChildrenInCart === 0) {
			$cartCountSelector.text(cart.item_count)
		// ELSE IF bundleChildren ARE present in cart, count bundleChildren pairs as one
		} else if (bundleChildrenInCart > 0) {
			$cartCountSelector.text((cart.item_count - (bundleChildrenInCart / 2)))
		}

    if (cart.item_count === 0) {
      $cartCountSelector.addClass("hide")
    } else {
      $cartCountSelector.removeClass("hide")
    }
  }

  getCart = function(callback){
    var params = {
      url: "/cart.js",
      dataType: "json",
      success: function(cart){
        currentCart = cart;
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      }
    }

    $.ajax(params)
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');

    ShopifyAPI.getCart(function(cart){
      removeBundlesFromCart(cart);
      cartUpdateCallback(cart);
    })
  };

  loadCartSettings = function(){
    let $script = $(settings.cartSettingsScript);
    let cart_settings_json = JSON.parse($script.html());

    if (cart_settings_json && cart_settings_json.cart_settings.length > 2) {
      cartSettings = JSON.parse(cart_settings_json.cart_settings)
    }
  };

  loadProductRecommendations = function(){
    let $script = $(settings.recommendationScript);
    let json = JSON.parse($script.html());

    cartNotesEnabled = json.cartNoteEnabled

    recommendations = json.products.map(function(product){
      return JSON.parse(product)
    })
  }

  getRecommendedProduct = function(cart){
    // var possibleRecommendations = []
    var cartHandles = cart.items.reduce(function(accumulator, item){
      accumulator.push(item.handle)
      return accumulator
    },[])

    var foundRec = recommendations.find(function(rec){
      return !cartHandles.includes(rec.handle)
    })

    var recommendedProduct;

    if (foundRec) {
      var params = {
        url: '/products/' + foundRec.handle + '.js',
        async: false,
        success: function(product){
          recommendedProduct = product
          recommendedProduct.text = foundRec.text;
          if (foundRec?.alt_product_title?.length) {
            recommendedProduct.alt_title = foundRec.alt_product_title;
          }
          if (foundRec?.product_highlight_color?.length) {
            recommendedProduct.product_highlight_color = foundRec.product_highlight_color;
          }
          if (foundRec?.featured_external_url?.length) {
            recommendedProduct.featured_external_url = foundRec.featured_external_url;
          }
        },
        dataType: "json"
      }

      $.ajax(params)
    }

    return recommendedProduct;
  }

  loadProductRecommendationsOverride = function(){
    let $script = $(settings.recommendationOverrideScript);
    let override_json = JSON.parse($script.html());

    if (override_json && override_json.overrides.length > 3) {
      recommendationsOverride = JSON.parse(override_json.overrides)
    }
  }

  getRecommendedProductOverride = function(cart){
    var foundOverride = false;
    var cartHandles = cart.items.reduce(function(accumulator, item){
      accumulator.push(item.handle)
      return accumulator
    },[])

    if (recommendationsOverride && recommendationsOverride.length) {
      if (cartHandles.includes(recommendationsOverride.handle)) {
        foundOverride = true;
      }
    }

    if (!foundOverride && recommendationsOverride && recommendationsOverride.handle) {
      var params = {
        url: '/products/' + recommendationsOverride.handle + '.js',
        async: false,
        success: function(product){
          recommendedProductOverride = product
          recommendedProductOverride.text = recommendationsOverride.text;
          if (recommendationsOverride.alt_product_title.length) {
            recommendedProductOverride.alt_title = recommendationsOverride.alt_product_title;
          }
          if (recommendationsOverride.product_highlight_color) {
            recommendedProductOverride.product_highlight_color = recommendationsOverride.product_highlight_color;
          }
          if (recommendationsOverride.override_trigger_product_id.length) {
            recommendedProductOverride.override_trigger_product_id = recommendationsOverride.override_trigger_product_id;
          }
        },
        dataType: "json"
      }

      $.ajax(params)
    }

    return recommendedProductOverride;
  }

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
		$formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  adjustItemQuantity = function(e){
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this)
    if ($this.val()) {
      var quantity = $this.val()
    } else {
      var quantity = $this.data('qty');
    }
    var key = $this.data('key')

    var data = {
      id: key,
      quantity: quantity
    }
    changeCart(data)
  }

  handleRemoveBundle = function(){
		let bundleID = $(this).data('bundle-id');
		let bundleChildren = $(`.ajaxcart--item[data-bundle-id=${bundleID}]`);
		var updates = {};

		bundleChildren.each(index => {
			let child = bundleChildren[index];
			let $child = $(child);
			let childKey = $child.data('line-item-key');
			updates[childKey] = 0;
		})

		let formData = {
			'updates': updates
		};

		jQuery.ajax({
			url: `/cart/update.js`,
			type: 'post',
			dataType: 'json',
			data: formData,
			beforeSend: function() {

			},
			success: function() {
				getCart();
			},
			complete: function() {

			}
		})
	}

  isProductADonation = function(itemID) {
    var donationIDs = [
      {
        amount: '$1',
        id: 41075478593694
      },
      {
        amount: '$5',
        id: 41075478626462
      },
      {
        amount: '$10',
        id: 41075478659230
      },
      {
        amount: '$25',
        id: 41075478691998
      },
      {
        amount: '$50',
        id: 41075483345054
      },
    ];

    if (donationIDs.find(item => parseInt(item.id) === parseInt(itemID))) {
      return true;
    } else {
      return false;
    };
  }

  selectRecommendationVariant = function() {
    var $recommendationForm = $('form.js-multi-variant-reco');
    var $recommendationFormSelect = $('select#reco-multi-variant-select');
    var $atcBtnText = $recommendationForm.find('.js-product-add-text');
    var $hiddenInput = $recommendationForm.find('input[name="id"]');
    var newRecoID = $recommendationFormSelect.val();
    var atcText = 'ADD TO ORDER - '

    if (isProductADonation(newRecoID)) {
      atcText = 'SELECT DONATION - '
    }

    var activeRecoOption = $('option[value="'+newRecoID+'"]');
    var newRecoText = activeRecoOption.text();

    $hiddenInput.val(newRecoID)
    $atcBtnText.text(atcText + newRecoText + '.00')
  }

  onCartUpdate = function(){
    // Event for any cart updates
    // get cart, build cart, update cart count
    // getCart();
    // openCart();
  }

  changeCart = function(data, callback){
    var params = {
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function(cart){
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      }
    }
    $.ajax(params);
  }



  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  openSlideCart = function (e) {
    if (e) {
      e.preventDefault();
    }

    var gorgiasChatWindow = $(settings.gorgiasWindow);
    var gorgiasChatWidget = $(settings.gorgiasWidget);
		var gorgiasChatCampaigns = $(settings.gorgiasCampaigns);
    var overlay = $(settings.overlay);

    $cartContainer.addClass(settings.activeClass);
    $closeCartButton.focus();

    overlay.css({
      top: 0
    });
    overlay.addClass([settings.activeClass, "cart-overlay"]);

    gorgiasChatWindow.css({ right: '555px', transition: 'right 0.2s ease-out 0s'});
    gorgiasChatWidget.css({ right: '555px', transition: 'right 0.2s ease-out 0s' });
    gorgiasChatCampaigns.css({ right: '555px', transition: 'right 0.2s ease-out 0s' });

    toggleNoScroll();
  };

  closeSlideCart = function(){
    var overlay = $(settings.overlay);
    var gorgiasChatWindow = $(settings.gorgiasWindow);
    var gorgiasChatWidget = $(settings.gorgiasWidget);

    $cartContainer.removeClass(settings.activeClass);
    overlay.removeClass([settings.activeClass, "cart-overlay"]);

    gorgiasChatWindow.css({ right: '22px', transition: 'right 0.2s ease-out 0s'  })
    gorgiasChatWidget.css({ right: '22px', transition: 'right 0.2s ease-out 0s'  })

    toggleNoScroll();
  }


  buildCart = function (cart) {
    // Start with a fresh cart div
    var preOrderInCart = false;
    var preOrderIsntOnlyProductInCart = false;
    var cartHasOnlyPreOrder = true;
    // var cartHasOnlyPromo = true;
    var recommendedProduct = getRecommendedProduct(cart);
    var recommendedOverrideProduct = getRecommendedProductOverride(cart);
    var overrideInCart = false;
    var overrideTriggerInCart = false;
    var recommendationOverrideShouldRender = false;
    var rechargeInCart = false;
    var atLeastOneBundleInCart = false;
		var bundleParents = [];
    $cartContainer.empty();
    $cartFooter.empty();
    // Show empty cart
    if (cart.item_count === 0) {
      cartCallback(cart);
    }

    updateCartCount(cart);

    // Handlebars.js cart layout
    var items = [],
        item = {},
        promotion = getPromotion(),
        data = {},
        source = $("#CartTemplate").html(),
        // subtotalSource = $('#CartTemplateSubtotal').html(),
        template = Handlebars.compile(source);
        // templateSubtotal = Handlebars.compile(subtotalSource);
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      var subscription = false;
      var hideSubscription = false;
			var itemIsBundleChild = false;
      var promoItem = 4927740280969;
      var blackOpsDonationProductId = 7041370783902;
      var prodImg = {};
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _medium, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        prodImg.src = cartItem.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
        prodImg.dataSrc = cartItem.image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // if (cartItem.product_type !== "promotion") {
      //   cartHasOnlyPromo = false;
      // }
      if (cartItem.product_type === "preorder") {
        preOrderInCart = true;
      }

      if (cartItem.product_type !== "preorder") {
        cartHasOnlyPreOrder = false;
      }

      if (preOrderInCart === true && cart.items.length > 1 && cartHasOnlyPreOrder === false) {
          preOrderIsntOnlyProductInCart = true;
      }

      if (cartItem.properties && cartItem.properties.shipping_interval_frequency) {
				if (parseInt(cartItem.properties.shipping_interval_frequency) === 1) {
					// var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type.replace('s', '').toLowerCase();
          var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type;
        } else {
          var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type + "s"
        }
      } else {
        var rechargeProperties = null
      }

      if (cartItem.properties && cartItem.properties.shipping_interval_frequency) {
        rechargeInCart = true;
        subscription = true;
      }

      if (cartItem.id === 33735843512457 || (cartItem.properties && cartItem.properties.shipping_interval_frequency && cartItem.properties.shipping_interval_frequency > 5)) {
        hideSubscription = true
      }

      // TS: Handle Custom Upsell Display Logic
      if (recommendationsOverride && recommendationsOverride.id && ((cartItem.id === parseInt(recommendationsOverride.id)) || (cartItem.product_id === blackOpsDonationProductId))) {
        overrideInCart = true
      }
      if (recommendationsOverride && recommendationsOverride.override_trigger_product_id && (cartItem.id === parseInt(recommendationsOverride.override_trigger_product_id))) {
        overrideTriggerInCart = true
      }
      if (overrideTriggerInCart || overrideInCart) {
        if (overrideInCart) {
          recommendationOverrideShouldRender = false
        } else {
          recommendationOverrideShouldRender = true
        }
      } else {
        recommendationOverrideShouldRender = false
      }


      if (cartItem.title.includes("12 Pack") || cartItem.title.includes("12 pack")) {
        packSizeShouldRender = true
				packSize = '12 Pack'
      } else if (cartItem.title.includes("6 Pack") || cartItem.title.includes("6 pack")) {
				packSizeShouldRender = true
				packSize = '6 Pack'
      } else if (cartItem.title.includes("Bundle") || cartItem.title.includes("bundle")) {
				packSizeShouldRender = true
				packSize = '2 Case Bundle'
			} else {
        packSizeShouldRender = false
      }

      if (cartItem.title.includes("10.00% Off Auto renew") ) {
        rechargePropsShouldRender = true
      }

      if (cartItem.product_type == 'promotion' || cartItem.title.includes('Sample Pack') || (recommendationsOverride && recommendationsOverride.handle && cartItem.handle.includes(recommendationsOverride.handle))) {
        var limitOne = true;
      } else {
        var limitOne = false;
      }

      var properties = {};
			let bundleParent = {
				bundleID: null,
				quantity: 1,
				bundleParentID: null,
				bundleParentTitle: null,
				bundleParentImgURL: '',
				bundleParentPdpURL: '',
				bundleChildTitle: null,
				bundleSiblingTitle: null
			}

      Object.keys(cartItem.properties).forEach(function(key){
				// IF Product is part of a bundle
        if (key.includes("Bundle")) {
					properties[key] = cartItem.properties[key];
					atLeastOneBundleInCart = true;
					itemIsBundleChild = true;

					if (key.includes("Bundle #")) {
						bundleParent["bundleID"] = cartItem.properties[key];

					} else if (key.includes("_Bundle Parent ID")) {
						bundleParent["bundleParentID"] = cartItem.properties[key];

					} else if (key.includes("_Bundle Parent Title")) {
						bundleParent["bundleParentTitle"] = cartItem.properties[key];

					} else if (key.includes("_Bundle Parent Image URL")) {
						bundleParent["bundleParentImgURL"] = cartItem.properties[key];

					} else if (key.includes("_Bundle Parent PDP URL")) {
						bundleParent["bundleParentPdpURL"] = cartItem.properties[key];

					} else if (key.includes("_Bundle Child Title")) {
						bundleParent["bundleChildTitle"] = cartItem.properties[key];

					} else if (key.includes("_Bundle Sibling Title")) {
						bundleParent["bundleSiblingTitle"] = cartItem.properties[key];
					}

				// ELSE Product is NOT part of a bundle
        } else if (!key.includes('_ig')) {
					properties[key] = cartItem.properties[key];
				}
      })


			if (itemIsBundleChild === true) {
				// IF there is not already a bundleParent, add one
				if (bundleParents.length === 0) {
					bundleParents.push(bundleParent)
				// ELSE there is at least one bundleParent, check to make sure we aren't adding a duplicate
				} else {
					let found = bundleParents.some(parent => parent.bundleID === cartItem.properties["Bundle #"]);
					if (!found) {
						bundleParents.push(bundleParent)
					}
				}
			}


      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.product_id,
        variant: cartItem.variant_id,
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.title.replace(" - 12 pack", "").replace(" - 12 Pack", "").replace(" -12 Pack", "").replace(" 12 Pack", "").replace(" - 12 pack", "").replace(" -12 pack", "").replace(" 12 pack", "").replace("10.00% Off Auto renew", "").replace("Hoplark Water - ", "").replace("Pre-Order - ", "").replace(" - 16 Ounce -", "").replace("- 16 Ounce-", "").replace("<br>", "").replace("Auto renew", "").replace("Auto Renew", ""),
        variation: cartItem.variant_title,
        properties: properties,
        rechargePropsShouldRender: rechargePropsShouldRender,
        rechargeProperties: rechargeProperties,
				packSize: packSize,
        packSizeShouldRender: packSizeShouldRender,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        subscription: subscription,
        hideSubscription: hideSubscription,
				itemIsBundleChild: itemIsBundleChild,
				parentBundleID: itemIsBundleChild ? cartItem.properties["Bundle #"] : null,
        unit: subscription ? cartItem.properties.shipping_interval_unit_type : '',
        frequency: subscription ? cartItem.properties.shipping_interval_frequency : '',
        promotion: cartItem.product_type === "promotion",
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney(cartItem.original_price, settings.moneyFormat),
        vendor: cartItem.vendor == 'Hoplark HopTea' ? 'hoptea' : cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        limitOne: limitOne,
        lineDiscount: cartItem.line_level_discount_allocations.length,
        lineDiscounts: cartItem.line_level_discount_allocations.map(function (obj) {
          return Object.keys(obj).reduce(function (acc, key) {
            if (key === "amount") {
              acc[key] = Shopify.formatMoney(obj[key], settings.moneyFormat);
            } else {
              acc[key] = obj[key];
            }
            return acc;
          }, {});
        }),
        lineDiscountedPrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),

        discounts: cartItem.discounts,
        discountPrice: Shopify.formatMoney(cartItem.original_price - cartItem.discounted_price, settings.moneyFormat),
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        discountedPrice: Shopify.formatMoney(cartItem.discounted_price, settings.moneyFormat)
      };

      if (item.id === promoItem && cart.total_price < 100 ){ //changed
        var id = item.variant;
        var line = item.line;
        ShopifyAPI.changeItem(line, 0, cartUpdateCallback);
      }

      items.push(item);
    });

    if (recommendedProduct && recommendedProduct.featured_image) {
      recommendedProduct.image = {}
      recommendedProduct.image.src = recommendedProduct.featured_image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      recommendedProduct.image.dataSrc = recommendedProduct.featured_image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
    }

    if (recommendedOverrideProduct && recommendedOverrideProduct.featured_image) {
      recommendedOverrideProduct.image = {}
      recommendedOverrideProduct.image.src = recommendedOverrideProduct.featured_image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
      recommendedOverrideProduct.image.dataSrc = recommendedOverrideProduct.featured_image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
    }

    // if (cartHasOnlyPromo) {
      // ShopifyAPI.clearCart(cartUpdateCallback);
      // items = [];
    // }

    // CART PROMOTION
    var promoInFooter = function(promo){
      var inFooter = true;
      $.each(cart.items, function(index, cartItem){
        if(cartItem.variant_id === promo.variants[0].id){
          inFooter = false;
        }
      })
      return inFooter;
    }

    var promoFilter = promotion.filter(function(promo){
      if(promoInFooter(promo)){
        if (cart.total_price < 100 ){ //changed
          return false //show nothing
        } else {
          return true
        }
      }
    })

    var promoMap = promoFilter.map(function(promo){
      return {
        variants: promo.variants,
        product: promo
      }
    });


    data = {
      emptyCart: cart.item_count === 0,
      totalItemsInCart: countBundleChildren(cart) > 0 ? ((cart.item_count - (countBundleChildren(cart) / 2))) : cart.item_count,
      items: items,
      note: cart.note,
      atLeastOneBundleInCart: atLeastOneBundleInCart,
			bundleParents: atLeastOneBundleInCart ? bundleParents : [],
      totalCartDiscount: cart.total_discount === 0 ? 0 : 0,
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      cartNoteEnabled: cartNotesEnabled,
      cartNote: cart.note,
			cartUnformattedPrice: cart.total_price,
      donationExternalURL: recommendedProduct?.featured_external_url,
      noteActive: !!cart.note,
      psaShouldRender: cartSettings && cartSettings.show_psa ? cartSettings.show_psa : false,
      psaContent: cartSettings && cartSettings.psa_content ? cartSettings.psa_content : '',
			rewardsPointsShouldRender: cartSettings && cartSettings.show_rewards_points ? cartSettings.show_rewards_points : false,
      recommendationShouldRender: !!recommendedProduct,
      recommendedProduct: recommendedProduct,
      recommendedProductTitle: recommendedProduct && recommendedProduct.alt_title ? recommendedProduct.alt_title : recommendedProduct && recommendedProduct.title ? recommendedProduct.title.replace("Hoplark Water - ", "") : '',
      recommendedProductVariants: recommendedProduct && recommendedProduct.variants && recommendedProduct.variants.length > 1 ? true : false,
      recommendedPrice: recommendedProduct ? Shopify.formatMoney(recommendedProduct.price, settings.moneyFormat) : null,
      recommendationOverrideShouldRender: recommendationOverrideShouldRender,
      recommendedOverrideProduct: recommendedOverrideProduct,
      recommendedOverrideProductTitle: recommendedOverrideProduct && recommendedOverrideProduct.alt_title ? recommendedOverrideProduct.alt_title : recommendedOverrideProduct && recommendedOverrideProduct.title ? recommendedOverrideProduct.title.replace("Hoplark Water - ", "") : '',
      recommendedOverrideProductVariants: recommendedOverrideProduct && recommendedOverrideProduct.variants && recommendedOverrideProduct.variants.length > 1 ? true : false,
      recommendedOverridePrice: recommendedOverrideProduct ? Shopify.formatMoney(recommendedOverrideProduct.price, settings.moneyFormat) : null,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      cartDiscount: cart.cart_level_discount_applications.length,
      cartDiscounts: cart.cart_level_discount_applications.map(function (obj) {
        return Object.keys(obj).reduce(function (acc, key) {
          if (key === "total_allocated_amount") {
            acc[key] = Shopify.formatMoney(obj[key], settings.moneyFormat);
          } else {
            acc[key] = obj[key];
          }
          return acc;
        }, {});
      }),
      totalCartDiscount: cart.total_discount === 0 ? 0 : `{{ 'cart.general.savings_html' | t: price: '[savings]' | json }}.replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat))`,
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      preOrder: preOrderInCart,
      preOrderIsntOnlyProductInCart: preOrderIsntOnlyProductInCart
    }

    $cartContainer.append(template(data));
    $('.js-reco-product-form').on('submit', function(evt) {
      evt.preventDefault();
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });

    var slider = $( '.product-slider' );

		if (slider.length) {
			slider.slick({
				arrows:false,
				slidesToShow: 1,
				variableWidth: true,
				infinite: false,
				centerMode: true
			});
		}

		var loyaltyLionPointsContainer = $('#ll--ajax-cart-points');
		if (loyaltyLionPointsContainer?.length && window.loyaltylion?.ui) {
			window.loyaltylion.ui.refresh();
		}

    $('.cart-select').on("change", function(){
      var $this = $(this);
      var variant = $this.val();
      var slideIndex = $('.productSlide[data-variant='+ variant +']').data('slickIndex');
      slider.slick("slickGoTo", slideIndex);
    })

    //Check if ReCharge and add class to send to recharge cart
    if (rechargeInCart) {
      $('.ajaxcart__checkout').addClass('js-recharge-redirect');
    } else {
      $('.ajaxcart__checkout').removeClass('js-recharge-redirect');
    }

    cartCallback(cart);
  };

  addNoScroll = function(){
    // only add to no scroll if the body doesn't already have it!
    if (!$(document.body).hasClass('no-scroll')) {
      scrollY = window.pageYOffset;

      $(document.body).css({ top: -(scrollY) + "px" });
      $('html').addClass('no-scroll');
      $(document.body).addClass('no-scroll');
    }
  }

  removeNoScroll = function(){
    $(document.body).removeClass('no-scroll');
    $(document.body).css({ top: '' });

    window.scrollTo(0, scrollY || 0);
    $('html').removeClass('no-scroll');
  }

  toggleNoScroll = function(){
    if ($(document.body).hasClass('no-scroll')) {
      removeNoScroll()
    } else {
      addNoScroll()
    }
  }

  getPromotion = function(){
    var promotion = [];

    jQuery.ajax('/products.json', {
      async: false,
      method: "GET",
      accepts: "json",
      dataType: "json",
      success: function(json){
        promotion = json.products.filter(function(product){
          return product.product_type === "promotion";
        })
      }
    })
    return promotion;
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

	handleBundlerATC = function(e) {
		// on bundlerParent pdp, clicking ATC will:
		// 1.) prevent default ATC behavior
		// 2.) parse the bundlerChildren from the bundlerParent
		// 3.) use the bundlerChildren IDs to add them both to the cart
		// 4.) use the bundlerParent ID to associate both children with original bundle
		// 5.) hide bundlerChildren that should now be in-cart
		// 6.) display bundlerParent, that is NOT actually in-cart....
		// 7.) @checkout, the discounted bundlerChildren will display
		// 8.) after order is processed, Finale will subtract / track the correct inventory
		// 9.) ?????

		e.preventDefault()

		let	$this = $(this);
		let $bundleChildren = $this.siblings('#bundleChildVariantID');
		let itemsToAdd = [];

		if ($bundleChildren.length > 0) {
			let bundleNumber = parseInt((Math.random() * 100000));

			$bundleChildren.each(item => {
				let bundleChildInput = $bundleChildren[item];
				let $bundleChildInput = $(bundleChildInput);
				let bundleChildId = $bundleChildInput.data("bundle-child-id");
				let bundleChildTitle = $bundleChildInput.data("bundle-child-title");
				let bundleSibling = $bundleChildInput.data("bundle-sibling-title");
				let bundleParentID = $bundleChildInput.data("bundle-parent-id");
				let bundleParentTitle = $bundleChildInput.data("bundle-parent-title");
				let bundleParentImgURL = $bundleChildInput.data("bundle-parent-img");
				let bundleParentPdpURL = $bundleChildInput.data("bundle-parent-pdp-url");

				let newItem = {
					id: bundleChildId,
					quantity: 1,
					properties: {
						"Bundle #": bundleNumber,
						"Bundle": bundleParentTitle,
						"_Bundle Child Title": bundleChildTitle,
						"_Bundle Sibling Title": bundleSibling,
						"_Bundle Parent ID": bundleParentID,
						"_Bundle Parent Title": bundleParentTitle,
						"_Bundle Parent Image URL": bundleParentImgURL,
						"_Bundle Parent PDP URL": bundleParentPdpURL
					}
				}

				// TS: pixel-helper.js.liquid | pixelAdapter.addToCart(newItem)
				// pixelAdapter.addToCart(newItem);

				// TS: Klaviyo "Added to Cart" Script
				var _learnq = _learnq || [];
				// _learnq.push(['track', 'Added to Cart', newItem]);

				itemsToAdd.push(newItem);
			})
		}

		let formData = {
			'items': itemsToAdd
		};

		jQuery.ajax({
			url: `/cart/add.js`,
			type: 'post',
			dataType: 'json',
			data: formData,
			beforeSend: function() {

			},
			success: function() {
				getCart();
				theme.mfpOpen("slide-cart");
			},
			complete: function() {

			}
		})
  }

  module = {
    init: init,
    load: loadCart,
    open: openSlideCart
  };

  return module;

}(ajaxCart || {}, jQuery));

// ===================
// ReCharge Custom JS
// ===================

var recharge = (function() {
  var settings = {
    subCardATC: '.js-product-card-btn'
  };

  handleSubPageATC = function() {
		let	$this = $(this);
		let variant_id = $this.data("id");
		let $frequencyParent = $(`.js-product-card-frequency[data-plans-container="${variant_id}"`);
		let frequencyContainer = $frequencyParent.find('.js-ship-frequency:radio:checked');
		let frequency = frequencyContainer.val();

    data = {
      "id": variant_id,
      "quantity": 1,
      "properties": {
        "shipping_interval_frequency": frequency,
        "shipping_interval_unit_type": "Weeks"
      }
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
			beforeSend: function() {
			},
      success: function(line_item) {

      },
			complete: function() {
			}
    });
  }

  // Initialize ReCharge functions
  var init = function() {
		$(settings.subCardATC).click(handleSubPageATC);
  }
  return {init: init};
})();

$(document).ready(function(){
  ajaxCart.init({
		cartContainer: '.js-cart-container',
    closeCart: '.js-close-cart',
    cartFooter: '#CartFooter',
    cartCountSelector: '#CartCount',
    cartCostSelector: '#CartCost',
    emptySelector: '.ajaxcart--empty',
    triggerSelector: '.js-cart-trigger',
    formSelector: '.js-product-form',
    addToCartSelector: '.js-product-add',
    moneyFormat: '${{amount}}'
  })
	recharge.init();
	inlineVideoPlayer.init();
	overlayVideoPlayer.init();
	subscriptionPermalinks.init();
	stickyATCInit();
	hopsTabs.init();
	collectionFilters.init();
  customSelect.init();
	marquee.init();
	loyaltyLionActivities.init();
  profilePanelMenus.init();
})
